var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRUndTErzeugungsanlagen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 458,
    height: 341,
    viewBox: "0 0 458 341",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "R&T Erzeugungsanlagen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M237.312 339.69L0.725586 203.369L0.764184 184.112L30.9178 174.281L237.312 284.285L267.656 318.977L237.312 339.69Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M237.317 340.242L0.729553 203.646V201.107L237.317 337.848V340.242Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M457.274 213.496L237.316 340.243L237.312 298.297L432.013 183.58L457.259 193.905L457.274 213.496Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.729553 184.163L237.312 321.451L457.26 193.905L220.533 69.0709L0.729553 184.163Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Baum"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M220.3 117.605C234.465 117.605 245.947 122.897 245.947 129.425C245.947 135.954 234.465 141.246 220.3 141.246C206.135 141.246 194.653 135.954 194.653 129.425C194.653 122.897 206.135 117.605 220.3 117.605Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M213.637 129.293L210.985 108.518C211.009 109.41 210.463 110.218 209.625 110.527C207.579 111.552 205.174 111.578 203.106 110.598C202.322 110.263 201.795 109.515 201.745 108.664L198.879 130.089C198.736 131.306 199.452 132.525 201.029 133.455C204.361 135.138 208.296 135.138 211.629 133.455C213.636 132.374 214.281 130.724 213.637 129.293Z",
    fill: "#816955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M189.21 71.4102C199.537 71.4102 207.908 80.1341 207.908 90.8958C207.908 101.658 199.537 110.381 189.21 110.381C178.884 110.381 170.513 101.658 170.513 90.8958C170.513 80.1341 178.884 71.4102 189.21 71.4102Z",
    fill: "#558835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M215.855 67.9698C225.034 67.9698 232.475 75.7319 232.475 85.3064C232.475 94.8814 225.034 102.643 215.855 102.643C206.677 102.643 199.235 94.8814 199.235 85.3064C199.235 75.7319 206.677 67.9698 215.855 67.9698Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M227.677 92.6132C221.158 96.338 210.627 96.338 204.107 92.6132C200.812 90.6797 199.164 88.1725 199.235 85.6647C198.806 88.3875 200.381 91.9699 204.034 94.1185C210.553 97.8438 221.084 97.8438 227.603 94.1185C230.331 92.5987 232.149 89.8455 232.476 86.7393C232.118 88.8891 230.543 90.9662 227.677 92.6132Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M201.674 84.0183C209.943 84.0183 216.647 90.9777 216.647 99.5636C216.647 108.149 209.943 115.108 201.674 115.108C193.405 115.108 186.701 108.149 186.701 99.5636C186.701 90.9777 193.405 84.0183 201.674 84.0183Z",
    fill: "#65A246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M212.348 107.001C206.474 110.368 197.016 110.368 191.146 107.001C188.133 105.281 186.705 102.984 186.776 100.769C186.418 103.205 187.851 106.429 191.074 108.363C196.948 111.729 206.405 111.729 212.276 108.363C214.746 107.002 216.383 104.507 216.646 101.699C216.36 103.634 214.923 105.498 212.348 107.001Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M210.841 96.6256C205.08 99.5628 198.262 99.5628 192.502 96.6256C190.581 95.7127 189.182 93.9706 188.708 91.8971C188.42 93.9754 189.712 96.1246 192.502 97.7716C198.262 100.708 205.08 100.708 210.841 97.7716C213.63 96.1955 214.858 94.0463 214.635 91.8971C214.422 93.6168 213.134 95.2638 210.841 96.6256Z",
    fill: "#D9D9D0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Waage"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fu\xC3\x83\xC5\xB8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M191.11 201.883C212.832 201.883 230.441 190.834 230.441 177.204C230.441 163.574 212.832 152.524 191.11 152.524C169.388 152.524 151.779 163.574 151.779 177.204C151.779 190.834 169.388 201.883 191.11 201.883Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M191.11 197.309C212.832 197.309 230.441 187.148 230.441 174.613C230.441 162.079 212.832 151.917 191.11 151.917C169.388 151.917 151.779 162.079 151.779 174.613C151.779 187.148 169.388 197.309 191.11 197.309Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M191.111 189.439C207.693 189.439 221.134 181.003 221.134 170.597C221.134 160.191 207.693 151.756 191.111 151.756C174.53 151.756 161.089 160.191 161.089 170.597C161.089 181.003 174.53 189.439 191.111 189.439Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M191.111 185.948C207.693 185.948 221.134 178.192 221.134 168.624C221.134 159.057 207.693 151.301 191.111 151.301C174.53 151.301 161.089 159.057 161.089 168.624C161.089 178.192 174.53 185.948 191.111 185.948Z",
    fill: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M191.303 181.516C204.425 181.516 215.062 174.838 215.062 166.6C215.062 158.363 204.425 151.685 191.303 151.685C178.182 151.685 167.544 158.363 167.544 166.6C167.544 174.838 178.182 181.516 191.303 181.516Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M191.212 180.281C204.334 180.281 214.971 173.888 214.971 166.003C214.971 158.118 204.334 151.725 191.212 151.725C178.09 151.725 167.453 158.118 167.453 166.003C167.453 173.888 178.09 180.281 191.212 180.281Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M163.874 175.925L163.824 178.525C163.824 178.525 166.131 182.453 173.744 185.998C173.744 184.51 173.744 182.75 173.744 182.75C173.744 182.75 167.679 180.472 163.864 175.915L163.874 175.925Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M156.285 185.163L156.141 188.498C156.141 188.498 159.902 193.716 169.233 197.731C169.233 196.244 169.233 193.475 169.233 193.475C169.233 193.475 161.167 190.626 156.275 185.153L156.285 185.163Z",
    fill: "#C7C7C7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Waage_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 58",
    d: "M245.948 121.078C258.525 121.078 274.253 126.361 274.943 141.453C275.634 156.544 265.912 159.843 256.752 163.142C247.591 166.441 230.97 164.076 223.08 156.544C212.212 160.285 197.298 167.177 197.298 167.177L191.997 167.848L190.679 162.837C194.037 161.321 202.561 156.544 217.191 147.933C209.084 129.752 231.853 121.078 245.948 121.078Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Main-2",
    d: "M198.204 165.031C198.072 167.075 193.681 167.904 191.454 167.925L191.444 167.915H191.07C188.844 167.894 184.665 167.065 184.533 165.021C184.402 162.977 183.269 145.512 183.218 143.923C183.167 142.335 182.176 115.855 181.68 104.572C181.184 93.2902 178.887 76.1797 181.235 59.5347C182.429 51.116 185.626 49.8006 187.012 42.1105C187.464 39.5983 187.701 37.0467 187.779 34.5292L195.35 32.3181C195.278 36.2886 195.344 39.7867 195.694 42.0093C196.615 47.8882 200.743 50.8226 201.502 59.5448C203.06 77.485 201.553 93.3003 201.057 104.583C200.581 115.369 199.559 142.355 199.519 143.934C199.478 145.512 198.335 162.987 198.204 165.031Z",
    fill: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Main-3",
    d: "M201.509 59.4951C200.447 49.4575 196.132 47.4023 195.606 42.2519C195.438 40.6075 195.4 37.4229 195.455 33.6125L193.355 34.4127C193.387 39.9488 193.788 44.7774 194.941 46.6039C198.273 51.8856 200.229 61.0199 200.284 70.2081C200.313 74.9548 197.381 155.845 196.597 159.922C195.27 166.825 193.155 167.669 193.155 167.669C194.262 167.669 197.581 167.192 198.21 165.247C198.779 161.417 198.709 154.033 199.346 146.687C199.731 142.225 200.305 117.663 200.963 106.897C201.772 93.6724 203.3 76.4842 201.509 59.4951Z",
    fill: "#A3A3A3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Main-4",
    d: "M182.612 59.8321C183.174 55.8507 187.004 50.098 188.39 42.4079C188.961 39.2325 189.307 36.0562 189.494 33.003L190.829 32.5867L190.38 41.9016C189.641 48.8328 186.402 53.8504 186.402 62.3127C186.402 69.5354 186.092 98.3795 186.162 105.442C186.334 124.445 187.573 149.665 187.957 160.775C188.099 164.868 189.807 167.848 189.807 167.848C187.723 167.522 186.585 167.189 185.552 166.506C185.42 164.462 184.646 145.81 184.596 144.221C184.545 142.632 183.784 116.336 183.288 105.054C182.792 93.7714 180.265 76.4771 182.612 59.8321Z",
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 137",
    cx: 157.52,
    cy: 179.97,
    rx: 31.7841,
    ry: 21.9146,
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Teller_Links"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ring",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.791 77.9581C138.709 77.9581 140.264 76.4032 140.264 74.4852C140.264 72.5672 138.709 71.0123 136.791 71.0123C134.873 71.0123 133.318 72.5672 133.318 74.4852C133.318 76.4032 134.873 77.9581 136.791 77.9581ZM136.791 76.6107C137.964 76.6107 138.915 75.6598 138.915 74.4869C138.915 73.314 137.964 72.3631 136.791 72.3631C135.618 72.3631 134.667 73.314 134.667 74.4869C134.667 75.6598 135.618 76.6107 136.791 76.6107Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M134.776 167.925C150.666 167.925 163.548 159.667 163.548 149.48C163.548 139.293 150.666 131.034 134.776 131.034C118.885 131.034 106.004 139.293 106.004 149.48C106.004 159.667 118.885 167.925 134.776 167.925Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M163.606 144.738L163.547 149.477L161.347 149.715L162.426 143.983L163.606 144.738Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M106.004 144.833V149.479L108.008 149.462L107.558 144.519L106.004 144.833Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M134.997 160.145C150.001 160.145 162.164 153.077 162.164 144.358C162.164 135.639 150.001 128.571 134.997 128.571C119.993 128.571 107.83 135.639 107.83 144.358C107.83 153.077 119.993 160.145 134.997 160.145Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M134.971 160.693C149.53 160.693 161.332 154.457 161.332 146.763C161.332 139.07 149.53 132.834 134.971 132.834C120.413 132.834 108.611 139.07 108.611 146.763C108.611 154.457 120.413 160.693 134.971 160.693Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M134.776 128.102C118.87 128.128 105.987 135.618 106.004 144.833C106.021 154.047 118.929 161.495 134.835 161.469C150.742 161.444 163.625 153.953 163.608 144.739C163.591 135.525 150.682 128.077 134.776 128.102V128.102ZM134.954 160.229C120.016 160.255 107.897 153.257 107.881 144.612C107.864 135.958 119.965 128.926 134.895 128.901C149.825 128.875 161.952 135.873 161.969 144.518C161.986 153.172 149.884 160.204 134.954 160.229Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.998 76.4229C137.304 76.4921 137.482 76.7452 137.394 76.9882L116.727 132.722C116.639 132.965 116.32 133.106 116.014 133.037C115.708 132.967 115.53 132.714 115.617 132.471L136.285 76.7376C136.372 76.4946 136.691 76.3537 136.998 76.4229Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.592 76.5572C136.899 76.4901 137.217 76.6332 137.301 76.8768L159.063 135.807C159.147 136.05 158.967 136.302 158.66 136.369C158.353 136.436 158.035 136.293 157.951 136.05L136.189 77.1197C136.105 76.8761 136.285 76.6243 136.592 76.5572Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.949 76.4862C137.258 76.5492 137.443 76.7987 137.364 77.0434L114.333 155.102C114.254 155.347 113.939 155.494 113.631 155.431C113.322 155.368 113.137 155.118 113.216 154.874L136.247 76.8149C136.326 76.5703 136.641 76.4231 136.949 76.4862Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.677 76.6039C136.994 76.5742 137.281 76.7534 137.318 77.0043L148.672 159.072C148.71 159.323 148.484 159.551 148.167 159.581C147.851 159.61 147.564 159.431 147.527 159.18L136.173 77.1121C136.135 76.8612 136.361 76.6337 136.677 76.6039Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M108.661 153.025V157.287C108.661 157.287 110.918 161.16 118.531 164.704C118.531 163.217 118.531 158.572 118.531 158.572C118.531 158.572 112.423 156.323 108.607 151.766L108.661 153.025Z",
    fill: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Teller_Rechts"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ring_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.789 27.4053C247.707 27.4053 249.262 25.8505 249.262 23.9325C249.262 22.0145 247.707 20.4596 245.789 20.4596C243.871 20.4596 242.316 22.0145 242.316 23.9325C242.316 25.8505 243.871 27.4053 245.789 27.4053ZM245.789 26.0555C246.962 26.0555 247.913 25.1047 247.913 23.9318C247.913 22.7588 246.962 21.808 245.789 21.808C244.616 21.808 243.665 22.7588 243.665 23.9318C243.665 25.1047 244.616 26.0555 245.789 26.0555Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M243.774 117.371C259.664 117.371 272.546 109.113 272.546 98.926C272.546 88.7388 259.664 80.4805 243.774 80.4805C227.883 80.4805 215.001 88.7388 215.001 98.926C215.001 109.113 227.883 117.371 243.774 117.371Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M217.662 102.399V106.661C217.662 106.661 219.919 110.534 227.532 114.079C227.532 112.591 227.532 107.946 227.532 107.946C227.532 107.946 221.424 105.697 217.608 101.14L217.662 102.399Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M272.604 94.1858L272.544 98.9245L270.345 99.1623L271.423 93.4299L272.604 94.1858Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M215.001 94.2792V98.9245L217.006 98.9076L216.555 93.965L215.001 94.2792Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M243.994 109.591C258.998 109.591 271.162 102.523 271.162 93.8034C271.162 85.0842 258.998 78.016 243.994 78.016C228.99 78.016 216.827 85.0842 216.827 93.8034C216.827 102.523 228.99 109.591 243.994 109.591Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M243.969 110.14C258.527 110.14 270.329 103.903 270.329 96.2102C270.329 88.517 258.527 82.2804 243.969 82.2804C229.41 82.2804 217.608 88.517 217.608 96.2102C217.608 103.903 229.41 110.14 243.969 110.14Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M243.774 77.5493C227.867 77.5747 214.984 85.0651 215.001 94.2793C215.018 103.494 227.927 110.941 243.833 110.916C259.739 110.89 272.622 103.4 272.605 94.1859C272.588 84.9716 259.68 77.5238 243.774 77.5493V77.5493ZM243.952 109.676C229.014 109.702 216.895 102.704 216.878 94.0585C216.861 85.4047 228.963 78.373 243.893 78.3475C258.822 78.3221 270.949 85.3198 270.966 93.9651C270.983 102.619 258.882 109.651 243.952 109.676Z",
    fill: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.995 25.8687C246.302 25.9379 246.479 26.191 246.392 26.434L225.724 82.1678C225.637 82.4108 225.318 82.5517 225.012 82.4825C224.705 82.4132 224.528 82.1602 224.615 81.9172L245.282 26.1834C245.37 25.9404 245.689 25.7995 245.995 25.8687Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.59 26.004C245.897 25.9369 246.214 26.08 246.299 26.3236L268.06 85.2536C268.145 85.4972 267.964 85.7491 267.657 85.8162C267.35 85.8833 267.033 85.7402 266.948 85.4966L245.187 26.5665C245.102 26.3229 245.282 26.0711 245.59 26.004Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.947 25.9315C246.255 25.9946 246.441 26.244 246.361 26.4887L223.331 104.548C223.252 104.792 222.937 104.939 222.629 104.876C222.32 104.813 222.135 104.564 222.214 104.319L245.244 26.2602C245.324 26.0156 245.638 25.8684 245.947 25.9315Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.675 26.0502C245.991 26.0205 246.278 26.1997 246.316 26.4506L257.67 108.519C257.707 108.77 257.481 108.997 257.165 109.027C256.848 109.057 256.562 108.878 256.524 108.627L245.17 26.5584C245.133 26.3075 245.359 26.08 245.675 26.0502Z",
    fill: "#A6A6A6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stange"
  }, /*#__PURE__*/React.createElement("g", {
    id: "StangeNeu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M185.935 32.6855L189.817 35.3432L253.476 13.9163L249.603 11.274L185.935 32.6855Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M253.902 19.0726L253.902 13.8278C229.384 22.0436 191.636 34.665 190.235 35.2657L189.129 48.598L253.902 19.0726Z",
    fill: "#A0A0A0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "StangeNeu-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M190.255 35.255L156.838 58.9695L128.455 71.0139L125.796 71.0834L124.693 68.8289L186.385 32.5995L188.941 33.174L190.255 35.255Z",
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M190.255 35.2541L191.182 41.187L189.152 48.5629L128.461 77.0842L128.461 71.0101L190.255 35.2541Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M124.702 68.8198L128.464 71.0048L128.464 77.0607L124.702 74.9539L124.702 68.8198Z",
    fill: "#B9B9B9"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "PVGro\xC3\x9F"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Schatten",
    d: "M138.748 218.333L309.978 129.1L412.451 198.542L253.707 288.25L138.748 218.333Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kompplett"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M278.492 190.179L295.158 191.965L331.309 171.33L286.444 142.906L241.49 168.755L278.492 190.179Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M304.565 177.726C304.565 180.149 308.11 182.114 312.481 182.114C316.853 182.114 320.397 180.149 320.397 177.726C320.397 175.303 316.853 173.339 312.481 173.339C308.11 173.339 304.565 175.303 304.565 177.726Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M304.572 177.585C304.569 177.632 304.565 177.679 304.565 177.726C304.565 180.149 308.109 182.113 312.481 182.113C316.852 182.113 320.397 180.149 320.397 177.726V179.883H320.39C320.271 182.248 316.777 184.146 312.481 184.146C308.109 184.146 304.565 182.182 304.565 179.758V177.585H304.572Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M300.142 109.347L263.642 130.55L297.46 186.747L335.075 164.945L300.142 109.347Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M299.646 111.078L265.5 131.101L299.059 184.158L333.215 164.002L299.646 111.078Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M271.533 137.922L277.057 134.7C277.61 134.377 278.378 133.308 277.57 132.182L274.619 127.531C274.296 127.041 273.289 126.863 272.737 127.185L266.88 130.575C266.327 130.898 266.055 131.511 266.234 132.115L269.508 137.275C270.025 138.003 270.98 138.245 271.533 137.922Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M280.1 132.951L285.624 129.728C286.176 129.406 286.945 128.337 286.136 127.211L283.186 122.56C282.863 122.07 281.856 121.892 281.304 122.214L275.446 125.604C274.893 125.926 274.621 126.539 274.801 127.144L278.074 132.304C278.591 133.032 279.546 133.274 280.1 132.951Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M276.445 145.368L281.97 142.146C282.522 141.823 283.29 140.754 282.482 139.628L279.532 134.977C279.209 134.487 278.202 134.309 277.649 134.631L271.791 138.021C271.239 138.343 270.967 138.957 271.147 139.561L274.42 144.72C274.937 145.448 275.892 145.69 276.445 145.368Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M285.044 140.426L290.568 137.203C291.122 136.881 291.889 135.811 291.081 134.684L288.13 130.035C287.807 129.544 286.8 129.366 286.248 129.689L280.391 133.079C279.838 133.401 279.566 134.014 279.746 134.618L283.019 139.778C283.536 140.506 284.491 140.748 285.044 140.426Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M288.66 127.954L294.184 124.731C294.737 124.409 295.505 123.34 294.696 122.214L291.746 117.563C291.423 117.073 290.416 116.895 289.864 117.217L284.007 120.607C283.454 120.929 283.182 121.542 283.361 122.147L286.635 127.306C287.152 128.034 288.107 128.276 288.66 127.954Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M297.227 122.983L302.752 119.76C303.304 119.438 304.073 118.368 303.264 117.242L300.314 112.592C299.991 112.102 298.984 111.923 298.431 112.246L292.574 115.636C292.021 115.958 291.749 116.571 291.929 117.175L295.202 122.335C295.719 123.063 296.674 123.305 297.227 122.983Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M293.576 135.398L299.101 132.176C299.654 131.853 300.421 130.784 299.613 129.658L296.663 125.007C296.34 124.517 295.333 124.339 294.78 124.661L288.922 128.051C288.37 128.373 288.098 128.987 288.279 129.591L291.552 134.751C292.068 135.479 293.024 135.721 293.576 135.398Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M302.173 130.457L307.698 127.235C308.25 126.912 309.019 125.842 308.21 124.716L305.26 120.066C304.937 119.576 303.93 119.398 303.378 119.72L297.52 123.111C296.968 123.432 296.695 124.046 296.875 124.649L300.148 129.809C300.665 130.537 301.62 130.779 302.173 130.457Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M281.224 152.927L286.749 149.705C287.301 149.382 288.07 148.312 287.261 147.186L284.311 142.536C283.988 142.045 282.981 141.867 282.428 142.19L276.571 145.579C276.018 145.902 275.746 146.516 275.927 147.119L279.2 152.279C279.716 153.007 280.672 153.249 281.224 152.927Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M289.795 147.954L295.319 144.732C295.872 144.409 296.64 143.34 295.831 142.214L292.881 137.563C292.558 137.073 291.551 136.895 290.999 137.217L285.142 140.607C284.589 140.93 284.317 141.543 284.497 142.147L287.77 147.307C288.286 148.035 289.242 148.277 289.795 147.954Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M286.008 160.533L291.532 157.311C292.085 156.988 292.853 155.919 292.045 154.793L289.094 150.142C288.771 149.652 287.764 149.474 287.212 149.796L281.355 153.186C280.802 153.508 280.53 154.121 280.709 154.726L283.983 159.885C284.5 160.613 285.455 160.855 286.008 160.533Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M294.633 155.627L300.157 152.404C300.71 152.082 301.478 151.013 300.67 149.887L297.719 145.236C297.396 144.746 296.389 144.568 295.837 144.89L289.98 148.28C289.428 148.602 289.155 149.216 289.335 149.82L292.608 154.98C293.125 155.708 294.08 155.95 294.633 155.627Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M298.353 142.957L303.877 139.734C304.43 139.412 305.198 138.342 304.39 137.216L301.439 132.566C301.116 132.076 300.109 131.898 299.557 132.22L293.699 135.61C293.147 135.932 292.875 136.545 293.054 137.149L296.328 142.309C296.845 143.037 297.8 143.279 298.353 142.957Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M306.922 137.985L312.447 134.762C312.999 134.44 313.767 133.371 312.959 132.244L310.009 127.594C309.686 127.104 308.679 126.926 308.126 127.248L302.269 130.638C301.717 130.96 301.444 131.573 301.624 132.178L304.897 137.337C305.414 138.065 306.369 138.307 306.922 137.985Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M303.267 150.537L308.792 147.315C309.345 146.992 310.113 145.923 309.304 144.796L306.353 140.146C306.03 139.656 305.023 139.478 304.471 139.8L298.613 143.19C298.061 143.513 297.789 144.126 297.969 144.73L301.243 149.89C301.759 150.618 302.715 150.86 303.267 150.537Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M311.871 145.604L317.395 142.381C317.948 142.059 318.716 140.99 317.908 139.864L314.957 135.213C314.634 134.723 313.627 134.545 313.075 134.867L307.218 138.257C306.665 138.579 306.393 139.192 306.572 139.797L309.846 144.956C310.363 145.684 311.319 145.926 311.871 145.604Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M290.673 168.097L296.198 164.874C296.751 164.552 297.519 163.482 296.71 162.356L293.76 157.706C293.437 157.216 292.43 157.037 291.877 157.36L286.02 160.75C285.467 161.072 285.195 161.685 285.376 162.289L288.649 167.449C289.165 168.177 290.121 168.419 290.673 168.097Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M299.238 163.126L304.763 159.903C305.316 159.581 306.083 158.511 305.275 157.385L302.325 152.735C302.001 152.245 300.994 152.067 300.442 152.389L294.584 155.779C294.032 156.101 293.76 156.714 293.94 157.318L297.214 162.478C297.73 163.206 298.686 163.448 299.238 163.126Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M295.586 175.543L301.11 172.32C301.663 171.997 302.431 170.928 301.623 169.802L298.672 165.151C298.349 164.661 297.342 164.483 296.79 164.806L290.932 168.195C290.38 168.518 290.108 169.131 290.287 169.735L293.561 174.895C294.078 175.623 295.033 175.865 295.586 175.543Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M304.183 170.6L309.707 167.378C310.26 167.055 311.028 165.985 310.219 164.859L307.269 160.209C306.946 159.719 305.939 159.54 305.387 159.863L299.53 163.253C298.977 163.575 298.705 164.188 298.884 164.792L302.158 169.952C302.674 170.68 303.63 170.922 304.183 170.6Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M307.802 158.128L313.326 154.905C313.879 154.583 314.647 153.514 313.838 152.387L310.888 147.737C310.565 147.247 309.558 147.069 309.006 147.391L303.149 150.781C302.596 151.103 302.324 151.716 302.503 152.321L305.777 157.48C306.293 158.208 307.248 158.45 307.802 158.128Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M316.368 153.156L321.892 149.934C322.445 149.611 323.213 148.541 322.404 147.415L319.454 142.765C319.131 142.274 318.124 142.096 317.572 142.419L311.714 145.809C311.162 146.132 310.89 146.745 311.069 147.348L314.343 152.508C314.86 153.237 315.815 153.478 316.368 153.156Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M312.713 165.573L318.237 162.35C318.79 162.027 319.558 160.958 318.749 159.832L315.799 155.182C315.476 154.691 314.469 154.513 313.917 154.836L308.059 158.225C307.506 158.548 307.235 159.161 307.414 159.765L310.688 164.925C311.204 165.653 312.16 165.895 312.713 165.573Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M321.316 160.63L326.84 157.408C327.393 157.085 328.161 156.016 327.353 154.89L324.402 150.239C324.079 149.749 323.072 149.571 322.52 149.893L316.663 153.283C316.111 153.606 315.838 154.219 316.018 154.823L319.291 159.983C319.808 160.711 320.763 160.953 321.316 160.63Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M300.517 183.059L306.042 179.836C306.595 179.514 307.363 178.444 306.554 177.318L303.604 172.668C303.281 172.177 302.274 171.999 301.721 172.322L295.864 175.712C295.311 176.034 295.039 176.647 295.22 177.251L298.493 182.411C299.009 183.139 299.965 183.381 300.517 183.059Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M309.116 178.116L314.641 174.893C315.193 174.571 315.961 173.502 315.153 172.376L312.203 167.725C311.88 167.235 310.873 167.057 310.32 167.379L304.463 170.769C303.911 171.091 303.638 171.704 303.818 172.309L307.091 177.468C307.608 178.196 308.563 178.438 309.116 178.116Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M317.646 173.09L323.171 169.867C323.723 169.545 324.491 168.475 323.683 167.348L320.733 162.699C320.41 162.208 319.403 162.03 318.85 162.353L312.992 165.743C312.44 166.065 312.168 166.678 312.348 167.282L315.621 172.442C316.138 173.17 317.093 173.412 317.646 173.09Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M326.249 168.147L331.774 164.924C332.326 164.601 333.095 163.532 332.286 162.406L329.336 157.756C329.013 157.265 328.006 157.087 327.453 157.41L321.596 160.799C321.044 161.122 320.771 161.735 320.952 162.339L324.225 167.499C324.741 168.227 325.697 168.469 326.249 168.147Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M296.992 112.872L329.893 165.911L296.992 112.872Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M296.992 112.872L329.893 165.911L296.992 112.872Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M294.845 114.195L327.747 167.234L294.845 114.195Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M294.845 114.195L327.747 167.234L294.845 114.195Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M288.536 117.925L321.437 170.964L288.536 117.925Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M288.536 117.925L321.437 170.964L288.536 117.925Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M286.391 119.248L319.293 172.287L286.391 119.248Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M286.391 119.248L319.293 172.287L286.391 119.248Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M280.081 122.858L312.982 175.897L280.081 122.858Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M280.081 122.858L312.982 175.897L280.081 122.858Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M277.937 124.18L310.838 177.219L277.937 124.18Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M277.937 124.18L310.838 177.219L277.937 124.18Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M271.628 127.791L304.53 180.83L271.628 127.791Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M271.628 127.791L304.53 180.83L271.628 127.791Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M269.486 129.114L302.388 182.153L269.486 129.114Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M269.486 129.114L302.388 182.153L269.486 129.114Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M299.702 110.906L299.881 111.002L265.494 131.1L265.33 131.004L299.702 110.906Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M299.879 111.002L299.937 111.199L265.713 131.136L265.683 131.006L299.879 111.002Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M265.496 131.098L265.332 131.004L298.694 184.246L299.056 184.465L265.496 131.098Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M265.499 131.098L265.658 131.005L299.205 184.379L299.059 184.465L265.499 131.098Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M299.702 111.334L299.561 111.417L333.273 164.22L333.487 164.302L299.702 111.334Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M299.644 111.137L299.881 110.999L333.752 164.148L333.488 164.303L299.644 111.137Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M333.203 164L333.414 164.058L299.154 184.213L299.11 184.076L333.203 164Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M333.411 164.057L333.487 164.302L299.203 184.38L299.151 184.212L333.411 164.057Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M263.64 130.546L262.401 132.25L296.209 188.438L297.458 186.746L263.64 130.546Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M297.45 186.735L296.21 188.438L333.374 166.764L335.075 164.944L297.45 186.735Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M240.878 211.683L257.543 213.469L293.695 192.834L248.829 164.41L203.876 190.259L240.878 211.683Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M266.952 199.23C266.952 201.653 270.496 203.617 274.867 203.617C279.239 203.617 282.782 201.653 282.782 199.23C282.782 196.807 279.239 194.842 274.867 194.842C270.496 194.842 266.952 196.807 266.952 199.23Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M266.958 199.089C266.956 199.135 266.952 199.183 266.952 199.23C266.952 201.653 270.495 203.617 274.867 203.617C279.238 203.617 282.782 201.653 282.782 199.23V201.386H282.777C282.658 203.752 279.163 205.649 274.867 205.649C270.495 205.649 266.952 203.685 266.952 201.262V199.089H266.958Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M262.525 130.85L226.025 152.053L259.843 208.25L297.458 186.447L262.525 130.85Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M262.029 132.581L227.881 152.604L261.441 205.662L295.597 185.505L262.029 132.581Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M233.915 159.427L239.439 156.204C239.991 155.882 240.76 154.812 239.951 153.686L237.001 149.036C236.678 148.545 235.671 148.367 235.118 148.69L229.262 152.079C228.709 152.402 228.437 153.015 228.616 153.619L231.889 158.779C232.406 159.507 233.361 159.749 233.915 159.427Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M242.488 154.455L248.012 151.232C248.564 150.91 249.333 149.841 248.524 148.714L245.574 144.064C245.251 143.574 244.244 143.396 243.692 143.718L237.835 147.108C237.282 147.43 237.01 148.043 237.189 148.648L240.463 153.807C240.979 154.535 241.935 154.777 242.488 154.455Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M238.829 166.871L244.354 163.648C244.906 163.326 245.675 162.257 244.866 161.131L241.916 156.48C241.593 155.99 240.586 155.812 240.033 156.134L234.176 159.524C233.624 159.846 233.351 160.459 233.531 161.064L236.804 166.223C237.321 166.951 238.276 167.193 238.829 166.871Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M247.432 161.929L252.957 158.707C253.509 158.384 254.278 157.314 253.469 156.188L250.519 151.538C250.196 151.048 249.189 150.87 248.636 151.192L242.779 154.582C242.226 154.904 241.954 155.518 242.134 156.121L245.407 161.281C245.924 162.009 246.879 162.251 247.432 161.929Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M251.044 149.457L256.568 146.234C257.121 145.912 257.89 144.843 257.08 143.716L254.13 139.066C253.807 138.576 252.8 138.398 252.248 138.72L246.39 142.11C245.838 142.432 245.566 143.045 245.746 143.65L249.019 148.809C249.536 149.538 250.491 149.779 251.044 149.457Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M259.614 144.485L265.139 141.263C265.692 140.94 266.46 139.871 265.651 138.745L262.702 134.094C262.378 133.604 261.371 133.426 260.818 133.749L254.961 137.139C254.409 137.46 254.136 138.074 254.317 138.678L257.59 143.838C258.106 144.566 259.062 144.808 259.614 144.485Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M255.959 156.902L261.483 153.679C262.036 153.357 262.804 152.287 261.996 151.161L259.045 146.511C258.722 146.021 257.715 145.842 257.163 146.165L251.306 149.555C250.753 149.877 250.481 150.49 250.661 151.094L253.934 156.254C254.451 156.982 255.406 157.224 255.959 156.902Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M264.562 151.96L270.086 148.738C270.64 148.415 271.407 147.346 270.599 146.22L267.648 141.569C267.325 141.079 266.318 140.901 265.766 141.223L259.908 144.613C259.356 144.935 259.084 145.549 259.264 146.153L262.538 151.313C263.054 152.041 264.01 152.283 264.562 151.96Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M243.609 174.43L249.134 171.207C249.687 170.884 250.456 169.815 249.647 168.689L246.696 164.038C246.372 163.548 245.365 163.37 244.813 163.693L238.957 167.082C238.403 167.405 238.132 168.018 238.312 168.622L241.585 173.782C242.101 174.51 243.056 174.752 243.609 174.43Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M252.179 169.458L257.704 166.235C258.256 165.913 259.024 164.843 258.216 163.716L255.265 159.067C254.942 158.576 253.935 158.398 253.383 158.721L247.526 162.111C246.974 162.433 246.701 163.046 246.881 163.65L250.154 168.81C250.671 169.538 251.626 169.78 252.179 169.458Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M248.394 182.036L253.919 178.813C254.472 178.491 255.24 177.422 254.431 176.296L251.481 171.645C251.158 171.155 250.151 170.977 249.598 171.299L243.741 174.689C243.188 175.011 242.916 175.624 243.097 176.229L246.37 181.388C246.886 182.116 247.842 182.358 248.394 182.036Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M257.013 177.13L262.537 173.907C263.091 173.585 263.858 172.516 263.05 171.389L260.099 166.739C259.776 166.249 258.769 166.071 258.217 166.393L252.36 169.783C251.808 170.105 251.535 170.718 251.715 171.323L254.989 176.482C255.505 177.21 256.461 177.452 257.013 177.13Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M260.743 164.46L266.267 161.237C266.82 160.915 267.588 159.846 266.779 158.719L263.829 154.069C263.506 153.579 262.499 153.401 261.947 153.723L256.09 157.113C255.537 157.435 255.265 158.048 255.445 158.653L258.718 163.812C259.235 164.54 260.19 164.782 260.743 164.46Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M269.312 159.488L274.837 156.266C275.389 155.943 276.157 154.874 275.349 153.747L272.399 149.097C272.076 148.607 271.069 148.429 270.516 148.752L264.658 152.142C264.106 152.464 263.834 153.077 264.014 153.681L267.287 158.84C267.804 159.569 268.76 159.81 269.312 159.488Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M265.657 172.041L271.181 168.819C271.734 168.496 272.502 167.426 271.693 166.3L268.743 161.65C268.42 161.159 267.413 160.981 266.861 161.304L261.004 164.694C260.451 165.016 260.179 165.63 260.358 166.233L263.632 171.393C264.148 172.121 265.103 172.363 265.657 172.041Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M274.258 167.107L279.782 163.884C280.335 163.561 281.103 162.492 280.295 161.365L277.344 156.715C277.021 156.225 276.014 156.047 275.462 156.37L269.604 159.759C269.052 160.082 268.78 160.695 268.96 161.299L272.233 166.459C272.75 167.187 273.705 167.429 274.258 167.107Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M253.054 189.6L258.579 186.378C259.131 186.055 259.9 184.986 259.091 183.859L256.141 179.209C255.818 178.719 254.811 178.541 254.259 178.863L248.401 182.253C247.849 182.576 247.576 183.189 247.756 183.793L251.029 188.953C251.546 189.681 252.501 189.923 253.054 189.6Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M261.627 184.629L267.151 181.407C267.704 181.084 268.472 180.014 267.663 178.888L264.713 174.238C264.39 173.748 263.383 173.569 262.831 173.892L256.974 177.282C256.421 177.604 256.149 178.218 256.328 178.821L259.602 183.981C260.119 184.709 261.074 184.951 261.627 184.629Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M257.967 197.045L263.492 193.822C264.044 193.5 264.812 192.431 264.004 191.305L261.054 186.654C260.731 186.164 259.724 185.986 259.171 186.308L253.314 189.698C252.762 190.02 252.489 190.633 252.67 191.238L255.943 196.398C256.459 197.126 257.415 197.368 257.967 197.045Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M266.571 192.103L272.096 188.88C272.648 188.558 273.417 187.488 272.608 186.362L269.658 181.712C269.335 181.222 268.328 181.044 267.775 181.366L261.918 184.756C261.365 185.078 261.093 185.691 261.273 186.295L264.546 191.455C265.063 192.183 266.018 192.425 266.571 192.103Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M270.188 179.63L275.712 176.408C276.265 176.085 277.033 175.016 276.224 173.89L273.274 169.239C272.951 168.749 271.944 168.571 271.392 168.894L265.535 172.284C264.982 172.605 264.71 173.219 264.89 173.823L268.163 178.983C268.679 179.711 269.635 179.953 270.188 179.63Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M278.756 174.659L284.281 171.437C284.834 171.114 285.602 170.045 284.793 168.919L281.843 164.268C281.52 163.778 280.513 163.6 279.96 163.922L274.103 167.312C273.551 167.634 273.278 168.247 273.459 168.852L276.732 174.012C277.248 174.74 278.204 174.982 278.756 174.659Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M275.097 187.076L280.622 183.854C281.174 183.531 281.942 182.462 281.134 181.336L278.184 176.685C277.861 176.195 276.853 176.017 276.301 176.34L270.444 179.73C269.892 180.052 269.619 180.665 269.799 181.269L273.072 186.429C273.589 187.157 274.544 187.399 275.097 187.076Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M283.701 182.134L289.226 178.911C289.778 178.589 290.546 177.52 289.738 176.393L286.788 171.743C286.465 171.253 285.458 171.075 284.905 171.397L279.047 174.787C278.495 175.109 278.223 175.722 278.403 176.327L281.676 181.486C282.193 182.215 283.149 182.456 283.701 182.134Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M262.902 204.562L268.426 201.34C268.979 201.017 269.747 199.947 268.939 198.821L265.988 194.171C265.665 193.681 264.658 193.503 264.106 193.826L258.249 197.216C257.696 197.538 257.424 198.151 257.604 198.754L260.877 203.914C261.394 204.643 262.349 204.884 262.902 204.562Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M271.505 199.619L277.029 196.396C277.582 196.074 278.35 195.005 277.541 193.878L274.591 189.228C274.268 188.738 273.261 188.56 272.709 188.882L266.851 192.272C266.298 192.594 266.027 193.207 266.207 193.812L269.48 198.972C269.996 199.7 270.952 199.942 271.505 199.619Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M280.031 194.592L285.555 191.37C286.107 191.047 286.876 189.977 286.067 188.851L283.117 184.201C282.794 183.711 281.787 183.533 281.235 183.855L275.378 187.245C274.825 187.567 274.553 188.181 274.733 188.784L278.006 193.944C278.522 194.672 279.478 194.914 280.031 194.592Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M288.635 189.65L294.16 186.427C294.712 186.105 295.48 185.036 294.672 183.909L291.722 179.259C291.399 178.769 290.392 178.591 289.839 178.913L283.981 182.303C283.429 182.625 283.157 183.238 283.337 183.843L286.61 189.002C287.127 189.73 288.082 189.972 288.635 189.65Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M259.373 134.375L292.275 187.414L259.373 134.375Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M259.373 134.375L292.275 187.414L259.373 134.375Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M257.232 135.698L290.133 188.737L257.232 135.698Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M257.232 135.698L290.133 188.737L257.232 135.698Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M250.92 139.427L283.821 192.466L250.92 139.427Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M250.92 139.427L283.821 192.466L250.92 139.427Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M248.778 140.751L281.679 193.79L248.778 140.751Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M248.778 140.751L281.679 193.79L248.778 140.751Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M242.465 144.361L275.367 197.4L242.465 144.361Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M242.465 144.361L275.367 197.4L242.465 144.361Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M240.322 145.683L273.224 198.722L240.322 145.683Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M240.322 145.683L273.224 198.722L240.322 145.683Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M234.011 149.294L266.912 202.333L234.011 149.294Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M234.011 149.294L266.912 202.333L234.011 149.294Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M231.867 150.617L264.769 203.656L231.867 150.617Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M231.867 150.617L264.769 203.656L231.867 150.617Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M262.086 132.41L262.266 132.506L227.878 152.604L227.714 152.507L262.086 132.41Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M262.268 132.504L262.326 132.701L228.101 152.64L228.072 152.51L262.268 132.504Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M227.88 152.602L227.716 152.507L261.078 205.75L261.441 205.968L227.88 152.602Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M227.879 152.602L228.038 152.509L261.586 205.882L261.439 205.969L227.879 152.602Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M262.083 132.837L261.942 132.921L295.653 185.723L295.868 185.805L262.083 132.837Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M262.028 132.64L262.265 132.501L296.136 185.65L295.872 185.805L262.028 132.64Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M295.586 185.503L295.797 185.561L261.537 205.716L261.493 205.579L295.586 185.503Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M295.792 185.56L295.868 185.805L261.584 205.882L261.532 205.715L295.792 185.56Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M226.03 152.049L224.791 153.752L258.599 209.942L259.848 208.249L226.03 152.049Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M259.833 208.238L258.593 209.941L295.755 188.266L297.458 186.447L259.833 208.238Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M364.92 208.066C364.92 210.489 368.465 212.453 372.836 212.453C377.208 212.453 380.751 210.489 380.751 208.066C380.751 205.643 377.208 203.678 372.836 203.678C368.465 203.678 364.92 205.643 364.92 208.066Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M364.926 207.925C364.924 207.971 364.92 208.019 364.92 208.066C364.92 210.489 368.463 212.453 372.835 212.453C377.207 212.453 380.751 210.489 380.751 208.066V210.223H380.745C380.626 212.588 377.132 214.486 372.835 214.486C368.463 214.486 364.92 212.521 364.92 210.098V207.925H364.926Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M360.495 139.686L323.995 160.889L357.813 217.086L395.428 195.284L360.495 139.686Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M359.997 141.418L325.85 161.44L359.41 214.498L393.565 194.341L359.997 141.418Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M331.884 168.263L337.409 165.04C337.961 164.717 338.729 163.648 337.921 162.522L334.971 157.871C334.648 157.381 333.641 157.203 333.088 157.526L327.23 160.915C326.678 161.238 326.406 161.851 326.586 162.455L329.859 167.615C330.376 168.343 331.331 168.585 331.884 168.263Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M340.456 163.291L345.98 160.068C346.533 159.746 347.301 158.676 346.493 157.55L343.542 152.9C343.219 152.41 342.212 152.232 341.66 152.554L335.802 155.944C335.25 156.266 334.978 156.879 335.157 157.483L338.431 162.643C338.948 163.371 339.903 163.613 340.456 163.291Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M336.805 175.708L342.329 172.486C342.882 172.163 343.65 171.093 342.841 169.967L339.891 165.317C339.568 164.827 338.561 164.649 338.009 164.971L332.151 168.361C331.599 168.683 331.327 169.296 331.506 169.9L334.78 175.06C335.297 175.788 336.252 176.03 336.805 175.708Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M345.402 170.765L350.927 167.543C351.48 167.22 352.247 166.151 351.439 165.025L348.489 160.374C348.166 159.884 347.159 159.706 346.606 160.028L340.749 163.419C340.197 163.741 339.924 164.354 340.105 164.958L343.378 170.118C343.894 170.846 344.85 171.088 345.402 170.765Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M349.019 158.294L354.544 155.071C355.096 154.749 355.864 153.679 355.056 152.553L352.106 147.903C351.783 147.413 350.776 147.235 350.223 147.557L344.366 150.947C343.813 151.269 343.541 151.882 343.721 152.486L346.994 157.646C347.511 158.374 348.467 158.616 349.019 158.294Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M357.586 153.322L363.11 150.099C363.663 149.777 364.431 148.707 363.622 147.58L360.672 142.931C360.349 142.44 359.342 142.262 358.79 142.585L352.932 145.975C352.38 146.297 352.108 146.91 352.287 147.514L355.561 152.674C356.078 153.402 357.033 153.644 357.586 153.322Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M353.927 165.738L359.452 162.515C360.005 162.193 360.773 161.123 359.964 159.997L357.014 155.347C356.691 154.857 355.684 154.679 355.131 155.001L349.274 158.391C348.722 158.713 348.449 159.326 348.63 159.93L351.903 165.09C352.419 165.818 353.375 166.06 353.927 165.738Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M362.531 160.796L368.055 157.574C368.607 157.251 369.376 156.182 368.567 155.056L365.617 150.405C365.294 149.915 364.287 149.737 363.735 150.059L357.878 153.449C357.325 153.771 357.053 154.384 357.232 154.989L360.505 160.149C361.022 160.877 361.977 161.119 362.531 160.796Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M341.579 183.265L347.104 180.043C347.657 179.72 348.424 178.651 347.616 177.525L344.666 172.874C344.343 172.384 343.336 172.206 342.783 172.528L336.926 175.918C336.374 176.241 336.101 176.854 336.282 177.458L339.555 182.618C340.071 183.346 341.027 183.588 341.579 183.265Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M350.147 178.294L355.672 175.071C356.225 174.749 356.993 173.68 356.184 172.554L353.234 167.903C352.911 167.413 351.904 167.235 351.351 167.557L345.494 170.947C344.942 171.269 344.669 171.882 344.85 172.487L348.123 177.646C348.639 178.374 349.595 178.616 350.147 178.294Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M346.366 190.872L351.891 187.65C352.443 187.327 353.211 186.258 352.403 185.132L349.453 180.481C349.129 179.991 348.122 179.813 347.57 180.135L341.713 183.525C341.161 183.848 340.888 184.461 341.068 185.065L344.341 190.225C344.858 190.953 345.813 191.195 346.366 190.872Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M354.988 185.967L360.513 182.744C361.065 182.422 361.833 181.352 361.025 180.226L358.075 175.576C357.752 175.085 356.744 174.907 356.192 175.23L350.334 178.62C349.782 178.942 349.51 179.555 349.69 180.159L352.963 185.319C353.48 186.047 354.435 186.289 354.988 185.967Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M358.711 173.296L364.236 170.074C364.788 169.751 365.556 168.682 364.748 167.556L361.798 162.905C361.475 162.415 360.467 162.237 359.915 162.559L354.058 165.949C353.506 166.272 353.233 166.885 353.413 167.489L356.686 172.649C357.203 173.377 358.158 173.619 358.711 173.296Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M367.277 168.326L372.801 165.103C373.354 164.78 374.122 163.711 373.314 162.584L370.363 157.934C370.04 157.444 369.033 157.266 368.481 157.589L362.624 160.978C362.071 161.301 361.799 161.914 361.979 162.518L365.252 167.678C365.769 168.406 366.724 168.648 367.277 168.326Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M363.625 180.877L369.149 177.655C369.702 177.332 370.47 176.263 369.661 175.137L366.711 170.486C366.388 169.996 365.381 169.818 364.829 170.141L358.972 173.531C358.419 173.853 358.147 174.466 358.326 175.07L361.6 180.229C362.117 180.958 363.072 181.199 363.625 180.877Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M372.226 175.944L377.751 172.721C378.303 172.399 379.071 171.329 378.263 170.202L375.313 165.553C374.99 165.062 373.983 164.884 373.43 165.207L367.573 168.597C367.021 168.919 366.748 169.532 366.928 170.136L370.201 175.296C370.718 176.024 371.674 176.266 372.226 175.944Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M351.023 198.436L356.547 195.213C357.101 194.891 357.868 193.821 357.06 192.695L354.109 188.045C353.786 187.555 352.779 187.377 352.227 187.699L346.369 191.089C345.817 191.411 345.545 192.024 345.725 192.628L348.998 197.788C349.515 198.516 350.47 198.758 351.023 198.436Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M359.593 193.465L365.118 190.243C365.671 189.92 366.438 188.851 365.63 187.725L362.68 183.074C362.357 182.584 361.35 182.406 360.797 182.729L354.939 186.119C354.387 186.441 354.115 187.054 354.296 187.658L357.569 192.817C358.085 193.546 359.041 193.787 359.593 193.465Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M355.942 205.882L361.467 202.659C362.019 202.337 362.788 201.268 361.979 200.142L359.029 195.491C358.706 195.001 357.699 194.823 357.146 195.145L351.289 198.535C350.736 198.857 350.464 199.47 350.644 200.075L353.917 205.234C354.434 205.963 355.389 206.204 355.942 205.882Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M364.54 200.94L370.064 197.717C370.617 197.394 371.385 196.325 370.576 195.199L367.626 190.548C367.303 190.058 366.296 189.88 365.744 190.203L359.887 193.592C359.334 193.915 359.062 194.528 359.242 195.132L362.515 200.292C363.032 201.02 363.987 201.262 364.54 200.94Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M368.152 188.466L373.677 185.244C374.229 184.921 374.998 183.852 374.189 182.726L371.239 178.075C370.916 177.585 369.909 177.407 369.357 177.73L363.499 181.12C362.946 181.441 362.674 182.055 362.854 182.659L366.127 187.818C366.644 188.547 367.599 188.788 368.152 188.466Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M376.722 183.495L382.246 180.273C382.799 179.95 383.567 178.881 382.759 177.755L379.808 173.104C379.485 172.614 378.478 172.436 377.926 172.758L372.068 176.148C371.516 176.471 371.244 177.084 371.423 177.688L374.697 182.848C375.214 183.576 376.169 183.818 376.722 183.495Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M373.072 195.912L378.596 192.689C379.149 192.367 379.917 191.298 379.109 190.171L376.158 185.521C375.835 185.031 374.828 184.853 374.276 185.175L368.418 188.565C367.866 188.887 367.594 189.5 367.774 190.105L371.048 195.264C371.564 195.992 372.52 196.234 373.072 195.912Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M381.669 190.971L387.194 187.748C387.746 187.425 388.515 186.356 387.706 185.23L384.756 180.579C384.433 180.089 383.426 179.911 382.873 180.234L377.016 183.623C376.464 183.946 376.191 184.559 376.371 185.163L379.644 190.323C380.161 191.051 381.116 191.293 381.669 190.971Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M360.87 213.399L366.395 210.176C366.948 209.854 367.715 208.784 366.907 207.658L363.957 203.008C363.634 202.518 362.627 202.339 362.074 202.662L356.217 206.052C355.665 206.374 355.392 206.987 355.573 207.591L358.846 212.751C359.362 213.479 360.318 213.721 360.87 213.399Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M369.475 208.455L374.999 205.233C375.552 204.91 376.32 203.841 375.511 202.715L372.561 198.064C372.238 197.574 371.231 197.396 370.679 197.718L364.822 201.108C364.269 201.431 363.997 202.044 364.176 202.648L367.45 207.808C367.967 208.536 368.922 208.778 369.475 208.455Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M378.006 203.428L383.53 200.206C384.082 199.883 384.851 198.814 384.042 197.688L381.092 193.037C380.769 192.547 379.762 192.369 379.21 192.691L373.352 196.081C372.799 196.403 372.527 197.017 372.707 197.621L375.98 202.78C376.497 203.508 377.452 203.75 378.006 203.428Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M386.603 198.486L392.127 195.263C392.68 194.941 393.448 193.871 392.64 192.744L389.689 188.095C389.366 187.604 388.359 187.426 387.807 187.749L381.95 191.139C381.397 191.461 381.125 192.074 381.305 192.678L384.578 197.838C385.095 198.566 386.05 198.808 386.603 198.486Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M357.345 143.212L390.247 196.25L357.345 143.212Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M357.345 143.212L390.247 196.25L357.345 143.212Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M355.206 144.534L388.107 197.573L355.206 144.534Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M355.206 144.534L388.107 197.573L355.206 144.534Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M348.89 148.264L381.791 201.303L348.89 148.264Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M348.89 148.264L381.791 201.303L348.89 148.264Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M346.748 149.587L379.649 202.626L346.748 149.587Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M346.748 149.587L379.649 202.626L346.748 149.587Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M340.435 153.197L373.336 206.236L340.435 153.197Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M340.435 153.197L373.336 206.236L340.435 153.197Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M338.295 154.52L371.196 207.559L338.295 154.52Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M338.295 154.52L371.196 207.559L338.295 154.52Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M331.985 158.13L364.886 211.169L331.985 158.13Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M331.985 158.13L364.886 211.169L331.985 158.13Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M329.836 159.453L362.737 212.492L329.836 159.453Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M329.836 159.453L362.737 212.492L329.836 159.453Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M360.061 141.246L360.24 141.342L325.853 161.44L325.689 161.343L360.061 141.246Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M360.238 141.341L360.295 141.538L326.072 161.475L326.042 161.345L360.238 141.341Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M325.855 161.438L325.69 161.344L359.052 214.586L359.415 214.805L325.855 161.438Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M325.852 161.438L326.011 161.345L359.559 214.718L359.412 214.805L325.852 161.438Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M360.059 141.673L359.918 141.757L393.629 194.559L393.844 194.641L360.059 141.673Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M359.997 141.477L360.234 141.338L394.106 194.488L393.842 194.642L359.997 141.477Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M393.557 194.339L393.767 194.397L359.507 214.552L359.463 214.415L393.557 194.339Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M393.768 194.397L393.844 194.642L359.56 214.719L359.508 214.552L393.768 194.397Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M323.997 160.885L322.757 162.59L356.565 218.778L357.814 217.086L323.997 160.885Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M357.803 217.075L356.563 218.778L393.727 197.103L395.428 195.284L357.803 217.075Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M325.973 231.515C325.973 233.938 329.517 235.903 333.888 235.903C338.26 235.903 341.804 233.938 341.804 231.515C341.804 229.092 338.26 227.128 333.888 227.128C329.517 227.128 325.973 229.092 325.973 231.515Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M325.979 231.374C325.977 231.421 325.973 231.468 325.973 231.515C325.973 233.938 329.517 235.903 333.889 235.903C338.261 235.903 341.804 233.938 341.804 231.515V233.672H341.798C341.679 236.038 338.186 237.935 333.889 237.935C329.517 237.935 325.973 235.971 325.973 233.548V231.374H325.979Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M321.552 163.135L285.052 184.339L318.87 240.536L356.485 218.733L321.552 163.135Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M321.052 164.868L286.906 184.89L320.465 237.948L354.621 217.792L321.052 164.868Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M292.939 191.713L298.464 188.49C299.016 188.167 299.785 187.098 298.976 185.971L296.026 181.321C295.703 180.831 294.696 180.653 294.143 180.975L288.286 184.365C287.733 184.688 287.461 185.301 287.641 185.905L290.914 191.065C291.431 191.793 292.386 192.035 292.939 191.713Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M301.512 186.741L307.036 183.519C307.588 183.196 308.357 182.127 307.548 181.001L304.598 176.35C304.275 175.86 303.268 175.682 302.716 176.005L296.858 179.395C296.306 179.717 296.033 180.33 296.213 180.934L299.486 186.094C300.003 186.823 300.958 187.064 301.512 186.741Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M297.853 199.159L303.378 195.936C303.93 195.613 304.698 194.544 303.89 193.418L300.94 188.767C300.617 188.277 299.61 188.099 299.057 188.422L293.2 191.811C292.648 192.134 292.375 192.747 292.555 193.351L295.828 198.511C296.345 199.239 297.3 199.481 297.853 199.159Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M306.456 194.216L311.98 190.993C312.533 190.671 313.301 189.601 312.493 188.475L309.542 183.825C309.219 183.334 308.212 183.156 307.66 183.479L301.802 186.869C301.25 187.191 300.978 187.804 301.158 188.408L304.431 193.568C304.948 194.296 305.903 194.538 306.456 194.216Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M310.071 181.743L315.595 178.52C316.147 178.198 316.916 177.129 316.107 176.002L313.157 171.352C312.834 170.862 311.827 170.684 311.275 171.006L305.418 174.396C304.865 174.718 304.593 175.331 304.772 175.936L308.045 181.095C308.562 181.823 309.517 182.065 310.071 181.743Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M318.643 176.772L324.167 173.55C324.72 173.226 325.488 172.157 324.679 171.031L321.729 166.381C321.406 165.89 320.399 165.712 319.847 166.035L313.99 169.424C313.437 169.747 313.165 170.361 313.344 170.964L316.617 176.124C317.134 176.852 318.089 177.094 318.643 176.772Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M314.983 189.189L320.507 185.966C321.061 185.644 321.828 184.575 321.02 183.448L318.069 178.798C317.746 178.308 316.739 178.13 316.187 178.452L310.33 181.842C309.778 182.164 309.505 182.777 309.685 183.382L312.959 188.541C313.475 189.269 314.431 189.511 314.983 189.189Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M323.587 184.247L329.112 181.024C329.664 180.702 330.432 179.632 329.624 178.506L326.674 173.856C326.351 173.365 325.344 173.187 324.791 173.51L318.934 176.9C318.382 177.222 318.109 177.835 318.289 178.439L321.562 183.599C322.079 184.327 323.034 184.569 323.587 184.247Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M302.631 206.715L308.155 203.492C308.708 203.17 309.476 202.101 308.667 200.975L305.717 196.324C305.394 195.834 304.387 195.656 303.835 195.978L297.978 199.368C297.425 199.69 297.153 200.303 297.333 200.908L300.606 206.067C301.123 206.795 302.078 207.037 302.631 206.715Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M311.203 201.744L316.728 198.521C317.28 198.199 318.048 197.13 317.24 196.003L314.29 191.353C313.966 190.863 312.959 190.685 312.407 191.007L306.55 194.397C305.998 194.719 305.725 195.332 305.905 195.937L309.179 201.097C309.695 201.825 310.651 202.067 311.203 201.744Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M307.414 214.323L312.939 211.1C313.491 210.777 314.259 209.708 313.451 208.582L310.501 203.932C310.178 203.441 309.171 203.263 308.618 203.586L302.761 206.975C302.209 207.298 301.936 207.911 302.116 208.515L305.389 213.675C305.906 214.403 306.861 214.645 307.414 214.323Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M316.039 209.417L321.564 206.194C322.116 205.871 322.885 204.802 322.076 203.675L319.126 199.026C318.803 198.535 317.796 198.357 317.243 198.68L311.386 202.069C310.834 202.392 310.561 203.005 310.741 203.609L314.014 208.769C314.531 209.497 315.486 209.739 316.039 209.417Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M319.765 196.746L325.29 193.523C325.842 193.201 326.61 192.131 325.802 191.004L322.852 186.355C322.528 185.864 321.521 185.686 320.969 186.009L315.112 189.399C314.56 189.721 314.287 190.334 314.467 190.938L317.74 196.098C318.257 196.826 319.212 197.068 319.765 196.746Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M328.333 191.774L333.857 188.552C334.41 188.229 335.178 187.16 334.369 186.034L331.419 181.383C331.096 180.893 330.089 180.715 329.537 181.037L323.68 184.427C323.127 184.749 322.855 185.363 323.034 185.967L326.308 191.127C326.824 191.855 327.78 192.097 328.333 191.774Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M324.678 204.327L330.202 201.105C330.755 200.782 331.523 199.713 330.714 198.587L327.764 193.936C327.441 193.446 326.434 193.268 325.882 193.59L320.025 196.98C319.472 197.302 319.2 197.915 319.38 198.52L322.653 203.679C323.17 204.407 324.125 204.649 324.678 204.327Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M333.274 199.393L338.799 196.171C339.351 195.848 340.12 194.779 339.311 193.652L336.361 189.002C336.038 188.512 335.031 188.334 334.478 188.656L328.621 192.046C328.068 192.368 327.796 192.982 327.976 193.586L331.249 198.745C331.766 199.473 332.721 199.715 333.274 199.393Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M312.08 221.887L317.604 218.665C318.158 218.342 318.925 217.272 318.117 216.146L315.166 211.496C314.843 211.006 313.836 210.828 313.284 211.151L307.427 214.541C306.874 214.862 306.602 215.476 306.782 216.079L310.056 221.239C310.572 221.968 311.527 222.209 312.08 221.887Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M320.643 216.916L326.168 213.694C326.721 213.371 327.488 212.301 326.68 211.175L323.73 206.525C323.407 206.034 322.4 205.856 321.847 206.179L315.99 209.569C315.438 209.891 315.165 210.504 315.346 211.108L318.619 216.268C319.135 216.996 320.091 217.238 320.643 216.916Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M316.992 229.332L322.517 226.109C323.069 225.787 323.837 224.717 323.029 223.591L320.079 218.941C319.756 218.451 318.749 218.273 318.196 218.595L312.339 221.985C311.787 222.307 311.514 222.92 311.694 223.524L314.967 228.684C315.484 229.412 316.439 229.654 316.992 229.332Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M325.596 224.389L331.121 221.166C331.673 220.844 332.442 219.775 331.633 218.649L328.683 213.998C328.36 213.508 327.353 213.33 326.8 213.652L320.943 217.042C320.39 217.364 320.118 217.977 320.298 218.582L323.571 223.742C324.088 224.47 325.044 224.712 325.596 224.389Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M329.205 211.918L334.73 208.696C335.282 208.372 336.051 207.303 335.242 206.177L332.292 201.526C331.969 201.036 330.962 200.858 330.41 201.181L324.552 204.57C324 204.893 323.727 205.506 323.907 206.11L327.18 211.27C327.697 211.998 328.652 212.24 329.205 211.918Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M337.774 206.945L343.299 203.723C343.851 203.4 344.619 202.331 343.811 201.205L340.861 196.554C340.538 196.064 339.53 195.886 338.978 196.208L333.121 199.598C332.569 199.921 332.296 200.534 332.476 201.138L335.749 206.298C336.266 207.026 337.221 207.268 337.774 206.945Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M334.122 219.363L339.647 216.141C340.199 215.818 340.967 214.749 340.159 213.623L337.209 208.972C336.886 208.482 335.879 208.304 335.326 208.626L329.469 212.016C328.917 212.338 328.644 212.952 328.824 213.556L332.097 218.715C332.614 219.444 333.57 219.685 334.122 219.363Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M342.723 214.421L348.248 211.198C348.8 210.876 349.568 209.806 348.76 208.68L345.81 204.03C345.487 203.54 344.48 203.361 343.927 203.684L338.07 207.074C337.518 207.396 337.245 208.009 337.425 208.613L340.698 213.773C341.215 214.501 342.17 214.743 342.723 214.421Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M321.926 236.848L327.45 233.626C328.003 233.303 328.771 232.234 327.962 231.108L325.012 226.457C324.689 225.967 323.682 225.789 323.13 226.111L317.273 229.501C316.72 229.823 316.448 230.437 316.628 231.041L319.901 236.2C320.418 236.928 321.373 237.17 321.926 236.848Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M330.522 231.906L336.047 228.683C336.599 228.361 337.368 227.291 336.559 226.164L333.609 221.515C333.286 221.024 332.279 220.846 331.727 221.169L325.869 224.559C325.317 224.881 325.044 225.494 325.224 226.098L328.497 231.258C329.014 231.986 329.969 232.228 330.522 231.906Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M339.056 226.879L344.58 223.656C345.132 223.334 345.901 222.265 345.092 221.139L342.142 216.488C341.819 215.998 340.812 215.82 340.26 216.142L334.403 219.532C333.85 219.854 333.578 220.467 333.757 221.072L337.03 226.231C337.547 226.959 338.502 227.201 339.056 226.879Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M347.657 221.936L353.181 218.714C353.734 218.391 354.502 217.322 353.693 216.196L350.743 211.545C350.42 211.055 349.413 210.877 348.861 211.199L343.003 214.59C342.451 214.911 342.179 215.525 342.359 216.129L345.632 221.288C346.149 222.017 347.104 222.258 347.657 221.936Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M318.398 166.661L351.3 219.7L318.398 166.661Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M318.398 166.661L351.3 219.7L318.398 166.661Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M316.259 167.985L349.16 221.024L316.259 167.985Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M316.259 167.985L349.16 221.024L316.259 167.985Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M309.946 171.714L342.847 224.753L309.946 171.714Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M309.946 171.714L342.847 224.753L309.946 171.714Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M307.804 173.036L340.706 226.075L307.804 173.036Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M307.804 173.036L340.706 226.075L307.804 173.036Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M301.488 176.647L334.389 229.686L301.488 176.647Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M301.488 176.647L334.389 229.686L301.488 176.647Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M299.348 177.971L332.25 231.01L299.348 177.971Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M299.348 177.971L332.25 231.01L299.348 177.971Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M293.035 181.58L325.936 234.619L293.035 181.58Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M293.035 181.58L325.936 234.619L293.035 181.58Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M290.893 182.903L323.794 235.942L290.893 182.903Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M290.893 182.903L323.794 235.942L290.893 182.903Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M321.109 164.696L321.289 164.792L286.902 184.89L286.738 184.793L321.109 164.696Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M321.29 164.79L321.348 164.987L287.124 184.926L287.094 184.795L321.29 164.79Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M286.902 184.889L286.738 184.793L320.1 238.036L320.463 238.255L286.902 184.889Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M286.909 184.889L287.068 184.796L320.616 238.169L320.469 238.256L286.909 184.889Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M321.109 165.124L320.968 165.207L354.679 218.01L354.893 218.092L321.109 165.124Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M321.054 164.926L321.291 164.787L355.163 217.936L354.899 218.091L321.054 164.926Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M354.61 217.789L354.82 217.847L320.56 238.002L320.517 237.865L354.61 217.789Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M354.818 217.847L354.893 218.092L320.61 238.169L320.558 238.002L354.818 217.847Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M285.048 184.336L283.808 186.039L317.617 242.229L318.866 240.536L285.048 184.336Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M318.859 240.524L317.62 242.228L354.783 220.554L356.485 218.733L318.859 240.524Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M203.014 233.571L219.68 235.357L255.831 214.722L210.966 186.297L166.012 212.147L203.014 233.571Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M229.088 221.118C229.088 223.541 232.632 225.506 237.004 225.506C241.376 225.506 244.919 223.541 244.919 221.118C244.919 218.695 241.376 216.731 237.004 216.731C232.632 216.731 229.088 218.695 229.088 221.118Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M229.091 220.977C229.088 221.024 229.084 221.072 229.084 221.118C229.084 223.541 232.628 225.506 237 225.506C241.372 225.506 244.915 223.541 244.915 221.118V223.275H244.91C244.791 225.64 241.296 227.538 237 227.538C232.628 227.538 229.084 225.573 229.084 223.15V220.977H229.091Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M224.665 152.738L188.165 173.941L221.983 230.138L259.598 208.336L224.665 152.738Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M224.169 154.469L190.022 174.492L223.582 227.55L257.737 207.393L224.169 154.469Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M196.054 181.315L201.579 178.092C202.132 177.77 202.9 176.701 202.091 175.575L199.141 170.924C198.818 170.434 197.81 170.256 197.258 170.578L191.4 173.968C190.848 174.29 190.576 174.903 190.756 175.508L194.03 180.667C194.546 181.395 195.502 181.637 196.054 181.315Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M204.627 176.343L210.151 173.121C210.704 172.798 211.472 171.729 210.663 170.603L207.713 165.952C207.39 165.462 206.383 165.284 205.83 165.606L199.974 168.996C199.421 169.319 199.149 169.932 199.328 170.536L202.602 175.696C203.119 176.424 204.074 176.666 204.627 176.343Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M200.968 188.761L206.493 185.539C207.045 185.216 207.814 184.147 207.004 183.021L204.055 178.37C203.731 177.88 202.724 177.702 202.172 178.024L196.315 181.414C195.761 181.736 195.49 182.349 195.669 182.954L198.943 188.113C199.46 188.841 200.415 189.083 200.968 188.761Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M209.57 183.818L215.096 180.596C215.648 180.273 216.416 179.204 215.607 178.078L212.658 173.427C212.335 172.937 211.327 172.759 210.774 173.082L204.918 176.472C204.366 176.793 204.094 177.407 204.274 178.011L207.546 183.17C208.063 183.899 209.018 184.14 209.57 183.818Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M213.181 171.346L218.706 168.123C219.258 167.8 220.027 166.731 219.217 165.605L216.268 160.954C215.944 160.464 214.937 160.286 214.385 160.609L208.528 163.998C207.975 164.321 207.703 164.934 207.882 165.538L211.156 170.698C211.673 171.426 212.628 171.668 213.181 171.346Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M221.75 166.374L227.275 163.151C227.827 162.829 228.596 161.759 227.787 160.633L224.837 155.983C224.514 155.493 223.507 155.315 222.954 155.637L217.097 159.027C216.545 159.349 216.272 159.962 216.452 160.566L219.725 165.726C220.242 166.454 221.197 166.696 221.75 166.374Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M218.099 178.792L223.625 175.569C224.177 175.246 224.945 174.177 224.136 173.051L221.187 168.401C220.863 167.91 219.856 167.732 219.303 168.055L213.447 171.444C212.894 171.767 212.623 172.38 212.802 172.984L216.075 178.144C216.592 178.872 217.547 179.114 218.099 178.792Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M226.699 173.848L232.224 170.626C232.776 170.303 233.545 169.234 232.736 168.108L229.786 163.457C229.463 162.967 228.456 162.789 227.903 163.111L222.046 166.501C221.493 166.823 221.221 167.436 221.401 168.041L224.674 173.2C225.191 173.928 226.146 174.17 226.699 173.848Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M205.746 196.318L211.27 193.096C211.823 192.773 212.591 191.704 211.782 190.578L208.832 185.927C208.509 185.437 207.502 185.259 206.95 185.581L201.093 188.971C200.54 189.294 200.268 189.907 200.447 190.511L203.721 195.671C204.238 196.399 205.193 196.641 205.746 196.318Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M214.317 191.347L219.843 188.124C220.395 187.802 221.163 186.733 220.354 185.607L217.405 180.956C217.082 180.466 216.074 180.288 215.522 180.61L209.665 184C209.112 184.322 208.841 184.935 209.021 185.54L212.293 190.699C212.81 191.427 213.765 191.669 214.317 191.347Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M210.53 203.924L216.055 200.702C216.608 200.379 217.376 199.31 216.567 198.184L213.617 193.533C213.293 193.043 212.286 192.865 211.734 193.187L205.877 196.577C205.324 196.9 205.052 197.513 205.232 198.117L208.506 203.277C209.023 204.005 209.978 204.247 210.53 203.924Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M219.159 199.019L224.685 195.796C225.237 195.474 226.005 194.404 225.196 193.278L222.247 188.628C221.923 188.138 220.916 187.96 220.363 188.282L214.506 191.672C213.953 191.994 213.681 192.607 213.861 193.211L217.135 198.371C217.652 199.099 218.607 199.341 219.159 199.019Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M222.874 186.349L228.398 183.126C228.951 182.804 229.72 181.735 228.911 180.609L225.961 175.958C225.637 175.468 224.63 175.29 224.078 175.612L218.22 179.002C217.668 179.324 217.396 179.937 217.575 180.542L220.849 185.701C221.366 186.429 222.321 186.671 222.874 186.349Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M231.445 181.377L236.97 178.154C237.522 177.832 238.29 176.763 237.481 175.636L234.532 170.986C234.209 170.496 233.202 170.318 232.648 170.64L226.792 174.03C226.24 174.352 225.967 174.965 226.147 175.57L229.42 180.729C229.937 181.457 230.892 181.699 231.445 181.377Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M227.793 193.929L233.318 190.707C233.871 190.384 234.639 189.314 233.83 188.188L230.88 183.538C230.557 183.048 229.55 182.87 228.997 183.193L223.139 186.583C222.587 186.905 222.315 187.518 222.495 188.121L225.769 193.281C226.285 194.01 227.241 194.251 227.793 193.929Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M236.392 188.995L241.917 185.773C242.47 185.45 243.238 184.381 242.429 183.254L239.479 178.604C239.155 178.114 238.148 177.936 237.596 178.258L231.739 181.648C231.186 181.971 230.914 182.584 231.094 183.188L234.368 188.348C234.885 189.076 235.84 189.318 236.392 188.995Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M215.193 211.489L220.718 208.266C221.271 207.944 222.039 206.874 221.23 205.748L218.28 201.098C217.957 200.608 216.949 200.43 216.397 200.752L210.541 204.142C209.988 204.464 209.717 205.077 209.896 205.681L213.169 210.841C213.686 211.569 214.641 211.811 215.193 211.489Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M223.76 206.517L229.284 203.295C229.837 202.972 230.605 201.903 229.796 200.777L226.846 196.126C226.523 195.636 225.516 195.458 224.964 195.781L219.107 199.171C218.554 199.493 218.282 200.106 218.461 200.71L221.735 205.87C222.252 206.598 223.207 206.84 223.76 206.517Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M220.107 218.935L225.632 215.712C226.184 215.39 226.953 214.321 226.144 213.195L223.194 208.544C222.871 208.054 221.864 207.876 221.311 208.198L215.454 211.588C214.902 211.91 214.629 212.523 214.809 213.128L218.082 218.287C218.599 219.016 219.554 219.257 220.107 218.935Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M228.704 213.992L234.228 210.769C234.781 210.447 235.549 209.378 234.741 208.252L231.79 203.601C231.467 203.111 230.46 202.933 229.907 203.255L224.05 206.645C223.498 206.967 223.226 207.58 223.406 208.185L226.68 213.344C227.196 214.072 228.152 214.314 228.704 213.992Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M232.323 201.519L237.848 198.297C238.4 197.974 239.168 196.905 238.36 195.778L235.41 191.128C235.087 190.638 234.08 190.46 233.526 190.783L227.67 194.173C227.118 194.495 226.845 195.108 227.025 195.712L230.298 200.871C230.815 201.6 231.77 201.841 232.323 201.519Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M240.895 196.547L246.419 193.325C246.972 193.002 247.74 191.933 246.931 190.807L243.982 186.156C243.658 185.666 242.651 185.488 242.099 185.81L236.242 189.2C235.689 189.522 235.417 190.136 235.596 190.74L238.87 195.9C239.387 196.628 240.342 196.87 240.895 196.547Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M237.234 208.965L242.759 205.742C243.311 205.42 244.079 204.351 243.271 203.224L240.321 198.574C239.998 198.084 238.991 197.906 238.437 198.228L232.581 201.618C232.029 201.94 231.756 202.553 231.936 203.158L235.21 208.317C235.726 209.046 236.682 209.287 237.234 208.965Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M245.838 204.022L251.363 200.799C251.915 200.477 252.683 199.408 251.875 198.282L248.925 193.631C248.602 193.141 247.595 192.963 247.042 193.285L241.184 196.675C240.632 196.997 240.36 197.611 240.54 198.215L243.814 203.375C244.33 204.103 245.286 204.345 245.838 204.022Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M225.04 226.45L230.566 223.227C231.118 222.905 231.886 221.836 231.077 220.709L228.128 216.059C227.805 215.569 226.797 215.391 226.244 215.713L220.388 219.103C219.835 219.425 219.564 220.038 219.744 220.643L223.016 225.802C223.533 226.53 224.488 226.772 225.04 226.45Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M233.643 221.508L239.168 218.285C239.72 217.963 240.488 216.894 239.68 215.768L236.73 211.117C236.407 210.627 235.399 210.449 234.846 210.771L228.989 214.161C228.437 214.483 228.165 215.096 228.345 215.701L231.618 220.86C232.135 221.589 233.09 221.83 233.643 221.508Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M242.168 216.481L247.692 213.259C248.245 212.935 249.013 211.866 248.204 210.74L245.254 206.089C244.931 205.599 243.924 205.421 243.371 205.744L237.515 209.134C236.962 209.456 236.69 210.07 236.869 210.673L240.143 215.833C240.66 216.561 241.615 216.803 242.168 216.481Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M250.772 211.539L256.296 208.316C256.849 207.994 257.617 206.925 256.808 205.798L253.858 201.148C253.535 200.658 252.528 200.48 251.976 200.802L246.118 204.192C245.566 204.514 245.294 205.127 245.473 205.732L248.747 210.891C249.264 211.619 250.219 211.861 250.772 211.539Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M221.512 156.265L254.413 209.303L221.512 156.265Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M221.512 156.265L254.413 209.303L221.512 156.265Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M219.368 157.588L252.269 210.627L219.368 157.588Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M219.368 157.588L252.269 210.627L219.368 157.588Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M213.058 161.316L245.959 214.355L213.058 161.316Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M213.058 161.316L245.959 214.355L213.058 161.316Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M210.918 162.64L243.82 215.679L210.918 162.64Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M210.918 162.64L243.82 215.679L210.918 162.64Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M204.603 166.25L237.504 219.289L204.603 166.25Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M204.603 166.25L237.504 219.289L204.603 166.25Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M202.456 167.572L235.359 220.611L202.456 167.572Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M202.456 167.572L235.359 220.611L202.456 167.572Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M196.15 171.182L229.051 224.221L196.15 171.182Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M196.15 171.182L229.051 224.221L196.15 171.182Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M194.009 172.506L226.91 225.545L194.009 172.506Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M194.009 172.506L226.91 225.545L194.009 172.506Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M224.224 154.297L224.404 154.393L190.016 174.492L189.851 174.395L224.224 154.297Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M224.405 154.394L224.463 154.591L190.239 174.528L190.209 174.398L224.405 154.394Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M190.019 174.49L189.853 174.396L223.217 227.638L223.579 227.857L190.019 174.49Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M190.021 174.49L190.18 174.397L223.728 227.77L223.581 227.857L190.021 174.49Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M224.222 154.726L224.08 154.81L257.792 207.612L258.007 207.694L224.222 154.726Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M224.165 154.529L224.402 154.391L258.274 207.54L258.01 207.694L224.165 154.529Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M257.725 207.391L257.935 207.449L223.675 227.604L223.632 227.467L257.725 207.391Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M257.931 207.45L258.007 207.694L223.722 227.772L223.671 227.605L257.931 207.45Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M188.162 173.938L186.924 175.642L220.73 231.831L221.979 230.138L188.162 173.938Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M221.973 230.128L220.733 231.831L257.895 210.156L259.598 208.337L221.973 230.128Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M288.112 253.404C288.112 255.827 291.656 257.792 296.027 257.792C300.399 257.792 303.943 255.827 303.943 253.404C303.943 250.981 300.399 249.017 296.027 249.017C291.656 249.017 288.112 250.981 288.112 253.404Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M288.118 253.264C288.116 253.31 288.112 253.358 288.112 253.405C288.112 255.828 291.656 257.792 296.028 257.792C300.4 257.792 303.943 255.828 303.943 253.405V255.561H303.937C303.818 257.927 300.325 259.824 296.028 259.824C291.656 259.824 288.112 257.86 288.112 255.437V253.264H288.118Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M283.689 185.024L247.189 206.228L281.007 262.424L318.622 240.622L283.689 185.024Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M283.188 186.756L249.042 206.778L282.601 259.836L316.757 239.68L283.188 186.756Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M255.078 213.601L260.603 210.378C261.155 210.056 261.923 208.987 261.115 207.861L258.165 203.21C257.842 202.72 256.835 202.542 256.282 202.864L250.425 206.254C249.873 206.576 249.6 207.189 249.78 207.794L253.053 212.953C253.57 213.681 254.525 213.923 255.078 213.601Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M263.647 208.63L269.172 205.407C269.724 205.085 270.492 204.015 269.684 202.889L266.734 198.239C266.411 197.749 265.404 197.57 264.851 197.893L258.994 201.283C258.442 201.605 258.169 202.218 258.349 202.822L261.622 207.982C262.139 208.71 263.094 208.952 263.647 208.63Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M259.993 221.046L265.518 217.823C266.07 217.501 266.839 216.432 266.03 215.306L263.08 210.655C262.757 210.165 261.75 209.987 261.197 210.309L255.34 213.699C254.788 214.021 254.515 214.634 254.695 215.239L257.968 220.399C258.485 221.127 259.44 221.369 259.993 221.046Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M268.591 216.105L274.115 212.883C274.668 212.559 275.436 211.49 274.627 210.364L271.677 205.714C271.354 205.223 270.347 205.045 269.795 205.368L263.937 208.757C263.385 209.08 263.113 209.693 263.293 210.297L266.566 215.457C267.082 216.185 268.038 216.427 268.591 216.105Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M272.208 203.632L277.732 200.409C278.285 200.087 279.053 199.018 278.245 197.891L275.294 193.241C274.971 192.751 273.964 192.573 273.412 192.895L267.555 196.285C267.003 196.607 266.73 197.22 266.91 197.825L270.183 202.984C270.7 203.712 271.655 203.954 272.208 203.632Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M280.776 198.661L286.3 195.439C286.853 195.116 287.621 194.046 286.813 192.92L283.862 188.27C283.539 187.78 282.532 187.601 281.98 187.924L276.123 191.314C275.571 191.636 275.298 192.25 275.478 192.853L278.751 198.013C279.268 198.741 280.223 198.983 280.776 198.661Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M277.122 211.077L282.646 207.854C283.199 207.532 283.967 206.463 283.158 205.337L280.208 200.686C279.885 200.196 278.878 200.018 278.326 200.34L272.469 203.73C271.916 204.052 271.644 204.665 271.824 205.27L275.097 210.43C275.613 211.158 276.569 211.4 277.122 211.077Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M285.719 206.135L291.243 202.912C291.796 202.59 292.564 201.521 291.756 200.395L288.805 195.744C288.482 195.254 287.475 195.076 286.923 195.398L281.065 198.788C280.513 199.11 280.241 199.723 280.421 200.328L283.694 205.487C284.211 206.215 285.166 206.457 285.719 206.135Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M264.771 228.605L270.296 225.382C270.848 225.06 271.616 223.991 270.808 222.865L267.858 218.214C267.535 217.724 266.528 217.546 265.975 217.868L260.118 221.258C259.566 221.58 259.293 222.193 259.473 222.798L262.746 227.957C263.263 228.685 264.219 228.927 264.771 228.605Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M273.342 223.633L278.866 220.411C279.418 220.088 280.187 219.019 279.378 217.892L276.428 213.242C276.105 212.752 275.098 212.574 274.546 212.896L268.688 216.286C268.135 216.609 267.864 217.222 268.043 217.826L271.317 222.986C271.833 223.714 272.789 223.956 273.342 223.633Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M269.552 236.211L275.076 232.988C275.629 232.666 276.397 231.597 275.588 230.471L272.638 225.82C272.315 225.33 271.308 225.152 270.756 225.474L264.899 228.864C264.346 229.186 264.074 229.799 264.253 230.404L267.527 235.563C268.043 236.291 268.998 236.533 269.552 236.211Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M278.178 231.305L283.703 228.082C284.255 227.76 285.024 226.691 284.215 225.564L281.265 220.914C280.942 220.424 279.935 220.246 279.382 220.568L273.525 223.958C272.973 224.28 272.7 224.893 272.88 225.498L276.153 230.658C276.67 231.386 277.625 231.628 278.178 231.305Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M281.899 218.635L287.424 215.413C287.976 215.09 288.745 214.021 287.936 212.894L284.986 208.244C284.663 207.754 283.656 207.576 283.103 207.898L277.246 211.288C276.694 211.611 276.421 212.224 276.601 212.828L279.874 217.988C280.391 218.716 281.346 218.958 281.899 218.635Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M290.471 213.663L295.995 210.441C296.548 210.118 297.317 209.049 296.507 207.923L293.557 203.272C293.234 202.782 292.227 202.604 291.675 202.926L285.817 206.317C285.264 206.639 284.993 207.252 285.173 207.856L288.446 213.016C288.962 213.745 289.918 213.986 290.471 213.663Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M286.813 226.215L292.338 222.993C292.891 222.67 293.658 221.601 292.85 220.475L289.9 215.824C289.577 215.334 288.57 215.156 288.017 215.478L282.16 218.868C281.608 219.19 281.335 219.803 281.516 220.408L284.789 225.567C285.305 226.296 286.261 226.537 286.813 226.215Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M295.419 221.282L300.943 218.06C301.496 217.737 302.264 216.668 301.455 215.542L298.505 210.891C298.182 210.401 297.175 210.223 296.623 210.546L290.765 213.936C290.213 214.258 289.941 214.871 290.12 215.475L293.394 220.635C293.911 221.364 294.866 221.605 295.419 221.282Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M274.218 243.775L279.743 240.552C280.296 240.23 281.064 239.161 280.255 238.034L277.305 233.384C276.982 232.894 275.975 232.716 275.422 233.038L269.565 236.428C269.013 236.75 268.74 237.363 268.921 237.968L272.194 243.128C272.71 243.856 273.666 244.098 274.218 243.775Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M282.782 238.804L288.306 235.582C288.859 235.258 289.627 234.189 288.818 233.063L285.868 228.412C285.545 227.922 284.538 227.744 283.986 228.067L278.129 231.457C277.576 231.779 277.304 232.393 277.484 232.996L280.757 238.156C281.274 238.884 282.229 239.126 282.782 238.804Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M279.131 251.22L284.655 247.997C285.208 247.675 285.976 246.606 285.168 245.479L282.217 240.829C281.894 240.339 280.887 240.161 280.335 240.483L274.478 243.873C273.925 244.195 273.653 244.808 273.833 245.413L277.106 250.572C277.623 251.3 278.578 251.542 279.131 251.22Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M287.735 246.278L293.26 243.055C293.812 242.733 294.58 241.664 293.772 240.538L290.822 235.887C290.498 235.397 289.491 235.219 288.939 235.541L283.081 238.931C282.529 239.253 282.257 239.866 282.437 240.471L285.71 245.63C286.227 246.359 287.183 246.6 287.735 246.278Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M291.341 233.805L296.865 230.583C297.418 230.26 298.186 229.191 297.378 228.065L294.427 223.414C294.104 222.924 293.097 222.746 292.545 223.068L286.688 226.459C286.135 226.78 285.863 227.394 286.042 227.998L289.316 233.158C289.833 233.886 290.788 234.128 291.341 233.805Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M299.91 228.834L305.435 225.612C305.987 225.289 306.756 224.22 305.947 223.094L302.997 218.443C302.674 217.953 301.667 217.775 301.114 218.097L295.257 221.487C294.705 221.809 294.432 222.423 294.612 223.027L297.885 228.187C298.402 228.915 299.357 229.157 299.91 228.834Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M296.255 241.251L301.779 238.029C302.332 237.706 303.1 236.637 302.292 235.511L299.341 230.86C299.018 230.37 298.011 230.192 297.459 230.515L291.602 233.905C291.049 234.227 290.777 234.84 290.956 235.444L294.23 240.604C294.747 241.333 295.702 241.574 296.255 241.251Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M304.865 236.309L310.389 233.086C310.941 232.764 311.71 231.695 310.901 230.568L307.951 225.918C307.628 225.428 306.621 225.25 306.069 225.572L300.211 228.962C299.658 229.284 299.386 229.897 299.566 230.502L302.839 235.661C303.356 236.39 304.311 236.631 304.865 236.309Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M284.064 258.736L289.589 255.514C290.141 255.191 290.91 254.122 290.101 252.996L287.151 248.345C286.828 247.855 285.821 247.677 285.269 248L279.411 251.39C278.859 251.712 278.586 252.325 278.767 252.929L282.04 258.089C282.556 258.818 283.512 259.059 284.064 258.736Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M292.669 253.794L298.193 250.571C298.746 250.249 299.514 249.18 298.706 248.053L295.755 243.403C295.432 242.913 294.425 242.735 293.873 243.057L288.015 246.447C287.463 246.769 287.191 247.383 287.37 247.987L290.644 253.147C291.161 253.875 292.116 254.117 292.669 253.794Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M301.194 248.767L306.719 245.545C307.271 245.222 308.039 244.153 307.231 243.027L304.281 238.376C303.957 237.886 302.95 237.708 302.398 238.03L296.541 241.42C295.989 241.742 295.716 242.355 295.896 242.96L299.169 248.119C299.686 248.848 300.641 249.089 301.194 248.767Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M309.792 243.825L315.317 240.602C315.869 240.28 316.638 239.21 315.829 238.084L312.879 233.434C312.556 232.944 311.549 232.766 310.996 233.088L305.139 236.478C304.586 236.8 304.314 237.413 304.494 238.017L307.767 243.177C308.284 243.905 309.24 244.147 309.792 243.825Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M280.538 188.551L313.44 241.59L280.538 188.551Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M280.538 188.551L313.44 241.59L280.538 188.551Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M278.394 189.874L311.296 242.913L278.394 189.874Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M278.394 189.874L311.296 242.913L278.394 189.874Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M272.079 193.602L304.98 246.641L272.079 193.602Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M272.079 193.602L304.98 246.641L272.079 193.602Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M269.936 194.926L302.838 247.965L269.936 194.926Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M269.936 194.926L302.838 247.965L269.936 194.926Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M263.623 198.536L296.524 251.575L263.623 198.536Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M263.623 198.536L296.524 251.575L263.623 198.536Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M261.484 199.859L294.385 252.898L261.484 199.859Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M261.484 199.859L294.385 252.898L261.484 199.859Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M255.175 203.469L288.076 256.508L255.175 203.469Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M255.175 203.469L288.076 256.508L255.175 203.469Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M253.025 204.792L285.927 257.831L253.025 204.792Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M253.025 204.792L285.927 257.831L253.025 204.792Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M283.245 186.584L283.425 186.68L249.037 206.778L248.873 206.682L283.245 186.584Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M283.426 186.679L283.484 186.876L249.26 206.815L249.23 206.685L283.426 186.679Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M249.043 206.777L248.878 206.682L282.241 259.925L282.603 260.143L249.043 206.777Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M249.041 206.777L249.2 206.684L282.747 260.057L282.601 260.144L249.041 206.777Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M283.247 187.013L283.106 187.096L316.818 239.899L317.032 239.981L283.247 187.013Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M283.191 186.816L283.428 186.677L317.3 239.826L317.036 239.981L283.191 186.816Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M316.744 239.678L316.955 239.736L282.695 259.891L282.652 259.754L316.744 239.678Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M316.956 239.736L317.032 239.981L282.748 260.058L282.696 259.891L316.956 239.736Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M247.187 206.224L245.947 207.928L279.756 264.117L281.005 262.424L247.187 206.224Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M280.997 262.413L279.757 264.117L316.921 242.442L318.622 240.622L280.997 262.413Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M191.224 243.175C191.224 245.598 194.768 247.562 199.139 247.562C203.511 247.562 207.055 245.598 207.055 243.175C207.055 240.752 203.511 238.787 199.139 238.787C194.768 238.787 191.224 240.752 191.224 243.175Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M191.23 243.033C191.228 243.08 191.224 243.128 191.224 243.174C191.224 245.597 194.768 247.562 199.139 247.562C203.511 247.562 207.055 245.597 207.055 243.174V245.331H207.049C206.931 247.697 203.436 249.594 199.139 249.594C194.768 249.594 191.224 247.63 191.224 245.207V243.033H191.23Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M186.804 174.795L150.304 195.998L184.123 252.195L221.737 230.393L186.804 174.795Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M186.308 176.526L152.161 196.549L185.721 249.607L219.877 229.45L186.308 176.526Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M158.195 203.372L163.719 200.15C164.272 199.827 165.04 198.758 164.231 197.632L161.281 192.981C160.958 192.491 159.951 192.313 159.398 192.635L153.542 196.025C152.989 196.348 152.717 196.961 152.896 197.565L156.17 202.725C156.686 203.453 157.641 203.695 158.195 203.372Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M166.763 198.4L172.287 195.177C172.84 194.855 173.609 193.785 172.799 192.659L169.85 188.009C169.526 187.519 168.519 187.34 167.967 187.663L162.109 191.053C161.556 191.375 161.285 191.988 161.464 192.592L164.738 197.752C165.254 198.48 166.21 198.722 166.763 198.4Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M163.107 210.818L168.632 207.596C169.184 207.273 169.952 206.203 169.144 205.077L166.194 200.427C165.871 199.937 164.864 199.758 164.31 200.081L158.454 203.471C157.902 203.793 157.629 204.406 157.809 205.01L161.082 210.17C161.599 210.898 162.554 211.14 163.107 210.818Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M171.706 205.875L177.23 202.653C177.783 202.33 178.551 201.26 177.742 200.134L174.792 195.484C174.469 194.993 173.462 194.815 172.91 195.138L167.052 198.528C166.499 198.85 166.228 199.464 166.407 200.067L169.681 205.227C170.197 205.956 171.153 206.197 171.706 205.875Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M175.317 193.403L180.842 190.18C181.394 189.858 182.162 188.788 181.354 187.662L178.404 183.012C178.081 182.521 177.074 182.343 176.52 182.666L170.664 186.056C170.112 186.378 169.839 186.991 170.019 187.595L173.292 192.755C173.809 193.483 174.765 193.725 175.317 193.403Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M183.888 188.431L189.414 185.208C189.966 184.886 190.734 183.817 189.925 182.69L186.976 178.04C186.652 177.55 185.645 177.372 185.092 177.694L179.235 181.084C178.682 181.406 178.41 182.019 178.59 182.624L181.864 187.783C182.381 188.511 183.336 188.753 183.888 188.431Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M180.231 200.848L185.755 197.625C186.309 197.303 187.076 196.234 186.268 195.108L183.317 190.457C182.994 189.967 181.987 189.789 181.434 190.111L175.578 193.501C175.025 193.823 174.753 194.436 174.932 195.041L178.207 200.2C178.723 200.928 179.678 201.17 180.231 200.848Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M188.835 195.905L194.36 192.683C194.913 192.36 195.681 191.291 194.872 190.165L191.922 185.514C191.598 185.024 190.591 184.846 190.039 185.168L184.181 188.558C183.629 188.881 183.357 189.494 183.536 190.098L186.81 195.258C187.327 195.986 188.282 196.228 188.835 195.905Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M167.886 218.376L173.411 215.153C173.963 214.831 174.732 213.762 173.922 212.636L170.973 207.985C170.65 207.495 169.642 207.317 169.09 207.639L163.233 211.029C162.68 211.351 162.409 211.964 162.589 212.569L165.861 217.728C166.378 218.456 167.333 218.698 167.886 218.376Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M176.458 213.404L181.982 210.181C182.535 209.859 183.303 208.79 182.495 207.663L179.544 203.013C179.221 202.523 178.214 202.345 177.661 202.667L171.804 206.057C171.252 206.379 170.98 206.992 171.16 207.597L174.434 212.756C174.95 213.484 175.906 213.726 176.458 213.404Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M172.67 225.982L178.194 222.759C178.746 222.437 179.515 221.368 178.706 220.242L175.756 215.591C175.433 215.101 174.426 214.923 173.873 215.245L168.016 218.635C167.463 218.957 167.192 219.57 167.371 220.175L170.644 225.334C171.161 226.062 172.116 226.304 172.67 225.982Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M181.293 221.076L186.818 217.853C187.37 217.53 188.139 216.461 187.33 215.335L184.38 210.684C184.057 210.194 183.05 210.016 182.497 210.339L176.64 213.728C176.088 214.051 175.815 214.664 175.995 215.268L179.268 220.428C179.785 221.156 180.74 221.398 181.293 221.076Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M185.012 208.405L190.536 205.182C191.089 204.86 191.857 203.791 191.048 202.665L188.098 198.014C187.775 197.524 186.768 197.346 186.215 197.668L180.359 201.058C179.806 201.38 179.534 201.993 179.713 202.598L182.987 207.757C183.504 208.486 184.459 208.727 185.012 208.405Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M193.58 203.434L199.104 200.212C199.658 199.889 200.426 198.82 199.617 197.693L196.666 193.043C196.343 192.553 195.336 192.375 194.784 192.697L188.926 196.087C188.374 196.41 188.102 197.023 188.281 197.627L191.556 202.787C192.072 203.515 193.027 203.757 193.58 203.434Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M189.929 215.986L195.454 212.764C196.007 212.441 196.775 211.372 195.966 210.246L193.016 205.595C192.693 205.105 191.685 204.927 191.133 205.25L185.277 208.64C184.724 208.962 184.453 209.575 184.632 210.179L187.905 215.338C188.422 216.067 189.377 216.308 189.929 215.986Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M198.532 211.053L204.057 207.83C204.609 207.507 205.377 206.438 204.569 205.311L201.619 200.662C201.296 200.171 200.289 199.993 199.735 200.316L193.878 203.705C193.326 204.028 193.054 204.641 193.234 205.245L196.507 210.405C197.024 211.133 197.98 211.375 198.532 211.053Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M177.332 233.547L182.856 230.324C183.41 230.002 184.177 228.932 183.369 227.806L180.418 223.156C180.095 222.666 179.088 222.487 178.536 222.81L172.679 226.2C172.127 226.522 171.854 227.135 172.034 227.739L175.308 232.899C175.824 233.627 176.78 233.869 177.332 233.547Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M185.898 228.574L191.423 225.352C191.976 225.029 192.744 223.96 191.935 222.834L188.985 218.183C188.662 217.693 187.654 217.515 187.102 217.838L181.246 221.228C180.693 221.55 180.421 222.163 180.601 222.767L183.874 227.926C184.391 228.655 185.346 228.896 185.898 228.574Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M182.246 240.991L187.771 237.768C188.323 237.446 189.092 236.377 188.282 235.251L185.333 230.6C185.009 230.11 184.002 229.932 183.45 230.254L177.592 233.644C177.039 233.966 176.768 234.579 176.947 235.184L180.221 240.343C180.738 241.071 181.693 241.313 182.246 240.991Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M190.843 236.049L196.368 232.826C196.92 232.504 197.688 231.434 196.879 230.308L193.93 225.658C193.607 225.167 192.599 224.989 192.047 225.312L186.19 228.702C185.637 229.024 185.365 229.637 185.544 230.241L188.818 235.401C189.335 236.129 190.29 236.371 190.843 236.049Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M194.455 223.576L199.981 220.354C200.533 220.031 201.301 218.961 200.492 217.835L197.543 213.185C197.219 212.695 196.212 212.517 195.659 212.84L189.802 216.229C189.249 216.552 188.977 217.165 189.157 217.768L192.431 222.928C192.948 223.657 193.903 223.898 194.455 223.576Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M203.025 218.605L208.55 215.383C209.102 215.059 209.871 213.99 209.062 212.864L206.112 208.214C205.789 207.723 204.782 207.545 204.229 207.868L198.372 211.257C197.82 211.58 197.547 212.194 197.727 212.797L201 217.957C201.517 218.685 202.472 218.927 203.025 218.605Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M199.375 231.022L204.9 227.799C205.453 227.477 206.221 226.407 205.412 225.281L202.462 220.631C202.139 220.141 201.131 219.963 200.579 220.285L194.722 223.675C194.169 223.997 193.897 224.61 194.077 225.214L197.351 230.374C197.868 231.102 198.823 231.344 199.375 231.022Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M207.973 226.079L213.498 222.856C214.05 222.534 214.818 221.465 214.009 220.339L211.06 215.688C210.737 215.198 209.729 215.02 209.176 215.342L203.319 218.732C202.767 219.054 202.495 219.667 202.675 220.272L205.948 225.431C206.465 226.16 207.42 226.401 207.973 226.079Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M187.181 248.508L192.705 245.285C193.258 244.963 194.026 243.893 193.217 242.766L190.267 238.117C189.944 237.626 188.937 237.448 188.385 237.771L182.528 241.161C181.975 241.483 181.703 242.096 181.882 242.7L185.156 247.86C185.673 248.588 186.628 248.83 187.181 248.508Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M195.778 243.565L201.303 240.342C201.855 240.02 202.624 238.95 201.814 237.824L198.865 233.174C198.541 232.684 197.534 232.506 196.982 232.828L191.124 236.218C190.571 236.54 190.3 237.153 190.479 237.757L193.753 242.917C194.27 243.645 195.225 243.887 195.778 243.565Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M204.303 238.538L209.828 235.316C210.38 234.993 211.149 233.923 210.339 232.797L207.39 228.147C207.066 227.656 206.059 227.478 205.507 227.801L199.649 231.191C199.097 231.513 198.825 232.127 199.004 232.73L202.278 237.89C202.795 238.618 203.75 238.86 204.303 238.538Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M212.907 233.596L218.432 230.373C218.985 230.051 219.753 228.982 218.944 227.855L215.994 223.205C215.671 222.715 214.663 222.537 214.111 222.859L208.255 226.249C207.702 226.571 207.431 227.184 207.61 227.789L210.883 232.948C211.4 233.676 212.355 233.918 212.907 233.596Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M183.654 178.321L216.555 231.36L183.654 178.321Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M183.654 178.321L216.555 231.36L183.654 178.321Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M181.508 179.644L214.411 232.683L181.508 179.644Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M181.508 179.644L214.411 232.683L181.508 179.644Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M175.194 183.373L208.095 236.412L175.194 183.373Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M175.194 183.373L208.095 236.412L175.194 183.373Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M173.054 184.696L205.956 237.735L173.054 184.696Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M173.054 184.696L205.956 237.735L173.054 184.696Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M166.744 188.306L199.645 241.345L166.744 188.306Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M166.744 188.306L199.645 241.345L166.744 188.306Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M164.6 189.63L197.501 242.669L164.6 189.63Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M164.6 189.63L197.501 242.669L164.6 189.63Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M158.283 193.239L191.184 246.278L158.283 193.239Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M158.283 193.239L191.184 246.278L158.283 193.239Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M156.143 194.563L189.045 247.602L156.143 194.563Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M156.143 194.563L189.045 247.602L156.143 194.563Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M186.365 176.355L186.544 176.451L152.157 196.549L151.993 196.452L186.365 176.355Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M186.54 176.451L186.599 176.648L152.375 196.586L152.346 196.455L186.54 176.451Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M152.158 196.547L151.994 196.453L185.356 249.695L185.719 249.914L152.158 196.547Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M152.157 196.547L152.316 196.454L185.863 249.827L185.717 249.914L152.157 196.547Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M186.361 176.783L186.22 176.867L219.932 229.669L220.146 229.751L186.361 176.783Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M186.301 176.585L186.539 176.446L220.409 229.595L220.145 229.75L186.301 176.585Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M219.86 229.449L220.07 229.507L185.809 249.662L185.767 249.525L219.86 229.449Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M220.07 229.506L220.146 229.751L185.862 249.828L185.81 249.661L220.07 229.506Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M150.303 195.994L149.064 197.698L182.872 253.887L184.121 252.194L150.303 195.994Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M184.112 252.183L182.874 253.887L220.036 232.212L221.737 230.392L184.112 252.183Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M250.252 275.461C250.252 277.884 253.797 279.849 258.167 279.849C262.539 279.849 266.083 277.884 266.083 275.461C266.083 273.038 262.539 271.074 258.167 271.074C253.797 271.074 250.252 273.038 250.252 275.461Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M250.251 275.32C250.249 275.367 250.245 275.415 250.245 275.461C250.245 277.885 253.789 279.849 258.161 279.849C262.533 279.849 266.076 277.885 266.076 275.461V277.618H266.07C265.951 279.984 262.458 281.881 258.161 281.881C253.789 281.881 250.245 279.917 250.245 277.494V275.32H250.251Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M245.825 207.081L209.324 228.285L243.142 284.482L280.757 262.679L245.825 207.081Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M245.324 208.813L211.177 228.836L244.737 281.894L278.893 261.737L245.324 208.813Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M217.214 235.659L222.739 232.436C223.291 232.113 224.059 231.044 223.251 229.918L220.301 225.267C219.977 224.777 218.97 224.599 218.417 224.922L212.561 228.311C212.009 228.634 211.736 229.247 211.916 229.851L215.189 235.011C215.706 235.739 216.662 235.981 217.214 235.659Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M225.784 230.687L231.309 227.464C231.862 227.142 232.63 226.072 231.821 224.945L228.871 220.296C228.547 219.805 227.54 219.627 226.988 219.95L221.131 223.34C220.578 223.662 220.306 224.275 220.486 224.879L223.76 230.039C224.277 230.767 225.232 231.009 225.784 230.687Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M222.129 243.104L227.653 239.882C228.206 239.559 228.974 238.49 228.165 237.364L225.215 232.713C224.892 232.223 223.885 232.045 223.333 232.367L217.476 235.757C216.923 236.08 216.651 236.693 216.83 237.297L220.104 242.457C220.62 243.185 221.576 243.427 222.129 243.104Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M230.732 238.161L236.257 234.939C236.809 234.616 237.578 233.547 236.768 232.421L233.819 227.77C233.495 227.28 232.488 227.102 231.936 227.424L226.078 230.814C225.525 231.136 225.254 231.749 225.433 232.354L228.707 237.514C229.224 238.242 230.179 238.484 230.732 238.161Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M234.343 225.689L239.867 222.466C240.42 222.143 241.188 221.074 240.379 219.947L237.429 215.297C237.106 214.807 236.099 214.629 235.547 214.952L229.69 218.341C229.137 218.664 228.865 219.277 229.044 219.881L232.318 225.041C232.834 225.769 233.79 226.011 234.343 225.689Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M242.913 220.717L248.438 217.495C248.99 217.172 249.759 216.103 248.951 214.977L246 210.326C245.676 209.836 244.669 209.658 244.117 209.98L238.26 213.371C237.708 213.693 237.436 214.306 237.616 214.91L240.888 220.07C241.405 220.798 242.36 221.04 242.913 220.717Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M239.257 233.134L244.781 229.911C245.334 229.589 246.102 228.519 245.293 227.393L242.344 222.743C242.02 222.252 241.013 222.074 240.461 222.397L234.604 225.787C234.051 226.109 233.779 226.722 233.958 227.326L237.232 232.486C237.749 233.214 238.704 233.456 239.257 233.134Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M247.857 228.193L253.382 224.97C253.934 224.648 254.703 223.578 253.894 222.452L250.944 217.802C250.621 217.312 249.614 217.133 249.061 217.456L243.204 220.846C242.65 221.168 242.379 221.781 242.56 222.385L245.832 227.545C246.349 228.273 247.304 228.515 247.857 228.193Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M226.91 250.661L232.434 247.438C232.987 247.116 233.755 246.047 232.947 244.921L229.996 240.27C229.673 239.78 228.666 239.602 228.113 239.924L222.257 243.314C221.704 243.636 221.432 244.249 221.611 244.854L224.885 250.013C225.402 250.741 226.357 250.983 226.91 250.661Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M235.477 245.69L241.002 242.467C241.555 242.145 242.323 241.075 241.514 239.949L238.564 235.299C238.241 234.809 237.233 234.631 236.681 234.953L230.823 238.343C230.271 238.665 229.999 239.278 230.179 239.882L233.453 245.042C233.969 245.77 234.925 246.012 235.477 245.69Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M231.693 258.269L237.218 255.046C237.771 254.724 238.538 253.654 237.73 252.528L234.78 247.878C234.456 247.388 233.449 247.21 232.897 247.532L227.04 250.922C226.488 251.244 226.215 251.857 226.395 252.461L229.669 257.621C230.185 258.349 231.141 258.591 231.693 258.269Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M240.317 253.361L245.842 250.138C246.394 249.816 247.162 248.747 246.354 247.62L243.404 242.97C243.081 242.48 242.074 242.302 241.52 242.624L235.664 246.014C235.112 246.336 234.839 246.949 235.019 247.554L238.293 252.713C238.809 253.442 239.765 253.683 240.317 253.361Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M244.038 240.692L249.562 237.469C250.115 237.147 250.883 236.077 250.075 234.951L247.124 230.301C246.801 229.811 245.794 229.632 245.242 229.955L239.385 233.345C238.832 233.667 238.56 234.28 238.739 234.884L242.013 240.044C242.53 240.772 243.485 241.014 244.038 240.692Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M252.611 235.72L258.136 232.498C258.689 232.175 259.457 231.106 258.648 229.98L255.698 225.329C255.375 224.839 254.368 224.661 253.815 224.983L247.957 228.374C247.405 228.696 247.133 229.309 247.314 229.913L250.587 235.072C251.103 235.801 252.059 236.042 252.611 235.72Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M248.952 248.272L254.476 245.05C255.029 244.727 255.797 243.658 254.988 242.532L252.038 237.881C251.715 237.391 250.708 237.213 250.156 237.535L244.298 240.925C243.745 241.247 243.474 241.86 243.654 242.465L246.927 247.624C247.443 248.352 248.399 248.594 248.952 248.272Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M257.556 243.338L263.08 240.116C263.633 239.793 264.401 238.724 263.593 237.598L260.642 232.947C260.319 232.457 259.312 232.279 258.76 232.602L252.902 235.992C252.35 236.314 252.078 236.927 252.257 237.531L255.531 242.691C256.048 243.419 257.003 243.661 257.556 243.338Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M236.351 265.832L241.877 262.61C242.429 262.287 243.197 261.218 242.388 260.091L239.439 255.441C239.115 254.951 238.108 254.773 237.555 255.095L231.698 258.485C231.145 258.808 230.873 259.421 231.053 260.025L234.327 265.185C234.844 265.913 235.799 266.155 236.351 265.832Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M244.922 260.861L250.447 257.639C250.999 257.316 251.767 256.247 250.959 255.121L248.009 250.47C247.686 249.98 246.679 249.802 246.126 250.124L240.269 253.515C239.717 253.836 239.444 254.45 239.624 255.054L242.897 260.213C243.414 260.941 244.369 261.183 244.922 260.861Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M241.265 273.278L246.79 270.055C247.343 269.733 248.111 268.664 247.302 267.537L244.353 262.887C244.03 262.397 243.022 262.219 242.469 262.541L236.612 265.931C236.059 266.253 235.787 266.866 235.967 267.471L239.241 272.63C239.758 273.358 240.713 273.6 241.265 273.278Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M249.868 268.335L255.393 265.112C255.945 264.789 256.713 263.72 255.905 262.594L252.955 257.943C252.632 257.453 251.625 257.275 251.072 257.598L245.214 260.987C244.662 261.31 244.39 261.923 244.571 262.527L247.843 267.687C248.36 268.415 249.316 268.657 249.868 268.335Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M253.481 255.863L259.006 252.641C259.558 252.318 260.327 251.248 259.518 250.122L256.568 245.472C256.245 244.982 255.238 244.804 254.686 245.126L248.828 248.517C248.276 248.838 248.003 249.452 248.183 250.055L251.456 255.215C251.973 255.943 252.928 256.185 253.481 255.863Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M262.053 250.891L267.578 247.668C268.13 247.346 268.898 246.277 268.09 245.151L265.14 240.5C264.817 240.01 263.81 239.832 263.257 240.154L257.4 243.544C256.848 243.866 256.575 244.479 256.755 245.084L260.028 250.244C260.545 250.972 261.5 251.214 262.053 250.891Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M258.395 263.309L263.92 260.087C264.472 259.764 265.24 258.694 264.432 257.568L261.482 252.918C261.159 252.428 260.152 252.249 259.599 252.572L253.742 255.962C253.19 256.285 252.917 256.898 253.097 257.501L256.37 262.661C256.887 263.39 257.843 263.631 258.395 263.309Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M266.999 258.366L272.524 255.143C273.076 254.821 273.844 253.752 273.036 252.625L270.086 247.975C269.763 247.485 268.756 247.307 268.203 247.629L262.345 251.019C261.793 251.341 261.521 251.954 261.701 252.559L264.974 257.718C265.491 258.446 266.446 258.688 266.999 258.366Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M246.2 280.794L251.725 277.572C252.277 277.249 253.046 276.179 252.237 275.053L249.287 270.403C248.964 269.913 247.957 269.735 247.404 270.058L241.547 273.447C240.995 273.77 240.722 274.383 240.902 274.986L244.176 280.146C244.692 280.875 245.648 281.116 246.2 280.794Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M254.802 275.852L260.326 272.629C260.878 272.307 261.647 271.238 260.838 270.111L257.888 265.461C257.565 264.971 256.558 264.793 256.006 265.115L250.148 268.505C249.595 268.827 249.324 269.44 249.503 270.045L252.776 275.204C253.293 275.932 254.248 276.174 254.802 275.852Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M263.329 270.824L268.853 267.602C269.406 267.278 270.174 266.209 269.365 265.083L266.415 260.433C266.092 259.942 265.085 259.764 264.533 260.087L258.676 263.476C258.123 263.799 257.851 264.412 258.03 265.016L261.304 270.176C261.821 270.904 262.776 271.146 263.329 270.824Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M271.931 265.882L277.456 262.659C278.008 262.337 278.776 261.267 277.968 260.14L275.018 255.491C274.695 255 273.688 254.822 273.135 255.145L267.277 258.535C266.725 258.857 266.453 259.47 266.633 260.074L269.906 265.234C270.423 265.962 271.379 266.204 271.931 265.882Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M242.674 210.608L275.576 263.646L242.674 210.608Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M242.674 210.608L275.576 263.646L242.674 210.608Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M240.532 211.931L273.433 264.969L240.532 211.931Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M240.532 211.931L273.433 264.969L240.532 211.931Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M234.218 215.66L267.119 268.699L234.218 215.66Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M234.218 215.66L267.119 268.699L234.218 215.66Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M232.075 216.983L264.977 270.021L232.075 216.983Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M232.075 216.983L264.977 270.021L232.075 216.983Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M225.762 220.593L258.663 273.632L225.762 220.593Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M225.762 220.593L258.663 273.632L225.762 220.593Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M223.621 221.916L256.522 274.955L223.621 221.916Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M223.621 221.916L256.522 274.955L223.621 221.916Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M217.314 225.526L250.215 278.565L217.314 225.526Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M217.314 225.526L250.215 278.565L217.314 225.526Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M215.161 226.849L248.062 279.888L215.161 226.849Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M215.161 226.849L248.062 279.888L215.161 226.849Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M245.385 208.641L245.565 208.737L211.177 228.836L211.013 228.739L245.385 208.641Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M245.567 208.736L245.624 208.933L211.4 228.872L211.371 228.741L245.567 208.736Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M211.178 228.834L211.013 228.739L244.376 281.982L244.739 282.2L211.178 228.834Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M211.177 228.835L211.336 228.742L244.884 282.115L244.738 282.201L211.177 228.835Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M245.387 209.069L245.246 209.153L278.958 261.955L279.172 262.037L245.387 209.069Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M245.326 208.872L245.563 208.734L279.435 261.883L279.171 262.037L245.326 208.872Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M278.886 261.734L279.096 261.793L244.835 281.948L244.793 281.811L278.886 261.734Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M279.096 261.793L279.172 262.037L244.887 282.115L244.836 281.948L279.096 261.793Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M209.326 228.281L208.088 229.984L241.894 286.174L243.143 284.481L209.326 228.281Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M243.133 284.471L241.894 286.174L279.056 264.499L280.757 262.68L243.133 284.471Z",
    fill: "#F8F8F9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 236.592,
    cy: 242.851,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 236.592,
    cy: 242.851,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M236.582 234.839L237.204 241.224H235.979L236.582 234.839Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M236.582 250.801L237.204 244.416H235.979L236.582 250.801Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M228.753 242.841L235.138 243.463L235.138 242.238L228.753 242.841Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M244.555 242.841L238.17 243.463L238.17 242.238L244.555 242.841Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_2",
    cx: 352.691,
    cy: 167.333,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_2",
    cx: 352.691,
    cy: 167.333,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M352.682 159.321L353.304 165.706H352.078L352.682 159.321Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_2",
    d: "M352.682 175.283L353.304 168.898H352.078L352.682 175.283Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_2",
    d: "M344.852 167.323L351.238 167.946L351.238 166.72L344.852 167.323Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_2",
    d: "M360.655 167.323L354.269 167.946L354.269 166.72L360.655 167.323Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_3",
    cx: 251.906,
    cy: 156.6,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_3",
    cx: 251.906,
    cy: 156.6,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_3",
    d: "M251.896 148.588L252.518 154.974H251.293L251.896 148.588Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_3",
    d: "M251.896 164.551L252.518 158.166H251.293L251.896 164.551Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_3",
    d: "M244.067 156.591L250.452 157.213L250.452 155.988L244.067 156.591Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_3",
    d: "M259.869 156.591L253.484 157.213L253.484 155.988L259.869 156.591Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_4",
    cx: 318.36,
    cy: 230.94,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_4",
    cx: 318.36,
    cy: 230.94,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_4",
    d: "M318.35 222.928L318.973 229.313H317.747L318.35 222.928Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_4",
    d: "M318.35 238.891L318.973 232.506H317.747L318.35 238.891Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_4",
    d: "M310.521 230.931L316.906 231.553L316.906 230.328L310.521 230.931Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_4",
    d: "M326.323 230.931L319.938 231.553L319.938 230.328L326.323 230.931Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_5",
    cx: 181.765,
    cy: 199.526,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_5",
    cx: 181.765,
    cy: 199.526,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_5",
    d: "M181.756 191.514L182.378 197.899H181.152L181.756 191.514Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_5",
    d: "M181.756 207.477L182.378 201.091H181.152L181.756 207.477Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_5",
    d: "M173.926 199.517L180.311 200.139L180.311 198.913L173.926 199.517Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_5",
    d: "M189.729 199.517L183.343 200.139L183.343 198.913L189.729 199.517Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_6",
    cx: 364.059,
    cy: 197.93,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_6",
    cx: 364.059,
    cy: 197.93,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_6",
    d: "M364.05 189.918L364.672 196.303H363.447L364.05 189.918Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_6",
    d: "M364.05 205.88L364.672 199.495H363.447L364.05 205.88Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_6",
    d: "M356.22 197.92L362.606 198.543L362.606 197.317L356.22 197.92Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_6",
    d: "M372.022 197.92L365.637 198.543L365.637 197.317L372.022 197.92Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_7",
    cx: 229.598,
    cy: 183.16,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_7",
    cx: 229.598,
    cy: 183.16,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_7",
    d: "M229.588 175.148L230.21 181.533H228.985L229.588 175.148Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_7",
    d: "M229.588 191.111L230.21 184.725H228.985L229.588 191.111Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_7",
    d: "M221.759 183.151L228.144 183.773L228.144 182.547L221.759 183.151Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_7",
    d: "M237.561 183.151L231.176 183.773L231.176 182.547L237.561 183.151Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_8",
    cx: 288.247,
    cy: 142.318,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_8",
    cx: 288.247,
    cy: 142.318,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_8",
    d: "M288.237 134.306L288.86 140.691H287.634L288.237 134.306Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_8",
    d: "M288.237 150.268L288.86 143.883H287.634L288.237 150.268Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_8",
    d: "M280.408 142.308L286.793 142.931L286.793 141.705L280.408 142.308Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_8",
    d: "M296.21 142.308L289.825 142.931L289.825 141.705L296.21 142.308Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_9",
    cx: 301.744,
    cy: 191.393,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_9",
    cx: 301.744,
    cy: 191.393,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_9",
    d: "M301.734 183.381L302.357 189.766H301.131L301.734 183.381Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_9",
    d: "M301.734 199.344L302.357 192.959H301.131L301.734 199.344Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_9",
    d: "M293.905 191.384L300.29 192.006L300.29 190.781L293.905 191.384Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_9",
    d: "M309.707 191.384L303.322 192.006L303.322 190.781L309.707 191.384Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_10",
    cx: 282.319,
    cy: 241.255,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_10",
    cx: 282.319,
    cy: 241.255,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_10",
    d: "M282.31 233.243L282.932 239.628H281.707L282.31 233.243Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_10",
    d: "M282.31 249.205L282.932 242.82H281.707L282.31 249.205Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_10",
    d: "M274.481 241.245L280.866 241.867L280.866 240.642L274.481 241.245Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_10",
    d: "M290.283 241.245L283.898 241.867L283.898 240.642L290.283 241.245Z",
    fill: "white",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Baum_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M93.3597 196.947C107.534 196.947 119.024 202.241 119.024 208.774C119.024 215.307 107.534 220.603 93.3597 220.603C79.1857 220.603 67.6957 215.307 67.6957 208.774C67.6957 202.241 79.1857 196.947 93.3597 196.947Z",
    fill: "#5B703A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M86.692 208.642L84.0389 187.854C84.0626 188.746 83.5158 189.554 82.6775 189.863C80.63 190.889 78.2236 190.916 76.1542 189.935C75.3705 189.6 74.8432 188.851 74.7923 188L71.9252 209.438C71.7816 210.657 72.4986 211.876 74.0758 212.807C77.4102 214.491 81.3477 214.491 84.6826 212.807C86.6914 211.725 87.3369 210.073 86.692 208.642Z",
    fill: "#816955"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M62.2496 150.721C72.5831 150.721 80.9594 159.451 80.9594 170.22C80.9594 180.988 72.5831 189.717 62.2496 189.717C51.9168 189.717 43.5399 180.988 43.5399 170.22C43.5399 159.451 51.9168 150.721 62.2496 150.721Z",
    fill: "#558835"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M88.912 147.279C98.0969 147.279 105.543 155.046 105.543 164.627C105.543 174.208 98.0969 181.974 88.912 181.974C79.7278 181.974 72.2814 174.208 72.2814 164.627C72.2814 155.046 79.7278 147.279 88.912 147.279Z",
    fill: "#619640"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M100.741 171.938C94.2182 175.665 83.6804 175.665 77.1565 171.938C73.8585 170.003 72.2098 167.495 72.2814 164.985C71.8516 167.71 73.4282 171.295 77.0832 173.445C83.6059 177.172 94.1442 177.172 100.668 173.445C103.398 171.924 105.217 169.169 105.543 166.061C105.186 168.212 103.609 170.29 100.741 171.938Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M74.7214 163.338C82.9958 163.338 89.704 170.302 89.704 178.893C89.704 187.484 82.9958 194.448 74.7214 194.448C66.447 194.448 59.7388 187.484 59.7388 178.893C59.7388 170.302 66.447 163.338 74.7214 163.338Z",
    fill: "#65A246"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M85.4022 186.335C79.5245 189.705 70.0608 189.705 64.1867 186.335C61.1718 184.615 59.7425 182.316 59.814 180.099C59.4558 182.537 60.8899 185.763 64.1152 187.698C69.9929 191.067 79.456 191.067 85.3307 187.698C87.8025 186.337 89.4397 183.84 89.7034 181.031C89.4173 182.967 87.9795 184.831 85.4022 186.335Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M83.8945 175.953C78.1301 178.892 71.3074 178.892 65.5436 175.953C63.621 175.04 62.222 173.296 61.7468 171.222C61.4595 173.301 62.7518 175.452 65.5436 177.1C71.3074 180.039 78.1301 180.039 83.8945 177.1C86.6858 175.523 87.9138 173.372 87.6908 171.222C87.478 172.943 86.1894 174.591 83.8945 175.953Z",
    fill: "#D9D9D0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRUndTErzeugungsanlagen);
export default __webpack_public_path__ + "static/media/RUndTErzeugungsanlagen.4761271739657388c82881f1f9d88e8d.svg";
export { ForwardRef as ReactComponent };